//
// Game Controller
//
// The game controller tracks and looks after the current game state, and orchestrates components
// ----------------------------

gameController = {};
//////////////////////////////////////////////////////
// New Spinner
gameController.dynamicSpinner = true;
//////////////////////////////////////////////////////
gameController.inFreeSpins = false;
gameController.cyclingWins = false;
gameController.cyclingJustWinlines = false;
gameController.spinComplete = false;
gameController.nudgeSpinComplete = false;
gameController.justCaughtFish = false;
gameController.bonusSymbolsLanded = 0;
gameController.logoSymbolAnticipationReel = -1;
gameController.minBonusForFeature = 3; //should be data driven
gameController.nudgeArrowsPerReel = 3;
gameController.arrowAnimsCount = 0;
gameController.nudgeHasFinished = false;
gameController.arrowAnimsComplete = 0;
gameController.nudgeSectorSize = 52;
gameController.canSlamStop = false;
gameController.slamStopped = false;
gameController.preFSReelPrize = 0;
gameController.inBuyABonus = false;
gameController.inBuyABonusFirstSpin = true;
gameController.anticipationOn = false;
gameController.justHadFreeSpins = false;
gameController.nudgeGlowIntroComplete = false;
gameController.topReelAnimationsComplete = false;
gameController.timerFadeSpinsLoopIntoIdle = undefined;
gameController.spinTuneId = undefined;
gameController.idleTuneId = undefined;
gameController.spinHasMushroomPrizes = false;
gameController.reelspinId = 0;
gameController.magicBet = false;
gameController.symbolLandAnimator = undefined;
gameController.inRespin = false;
gameController.logoAnticipationSpin = false;
gameController.platformPaused = false;
gameController.platformPopupActive = false;

gameController.isTopHitReelNudged = undefined;
gameController.symbolReelsToNudge = undefined;
gameController.topHitReelAfterNudge = undefined;
gameController.topHitReelBeforeNudge = undefined;
gameController.fishData = undefined;
gameController.fishWinAmount = undefined;
gameController.fullSymbolsOnTopHitReel = undefined;
gameController.currentTopReelAnimation = undefined;
gameController.fullScreenBubblesFront = undefined;
gameController.fullScreenBubblesBack = undefined;
gameController.nudgeReelPositions = [];
gameController.wildTransitionAnims = [];
gameController.symbolFramePanels = [];
gameController.nudgeFrameGlows = [];
gameController.nudgeArrows = [];
gameController.nudgeDirections = [];
gameController.wildBubbleEmitterPool = [];
gameController.wildPanelMultipliers = [];
gameController.freeSpinsWildTransitions = [];
gameController.topReelAnimationQueue = [];
gameController.nudgeAllowedOnReel = [];
gameController.fishCashOverlayAnimations = [];
gameController.fishermanCashValues = [];
gameController.topReelMultiplierText = [];
gameController.canSkipWin = false;
gameController.inRecovery = false;
gameController.inBuyABonusRecovery = false;
gameController.postGambleFsCount = 0;
gameController.wildBubbleEmitterUniqueID = 0;
gameController.mainReelAnticipationSoundStarted = false;
gameController.nudgeReelAnticipationSoundStarted = false;
gameController.mainAnticipationEmitters = [];
gameController.nudgeAnticipationEmitters = [];
gameController.greyScaleCashFishText = true;
gameController.dualWinOccurred = false;
gameController.lineWinsOnly = 0;
gameController.currentFishermanMultiplier = 1;
gameController.lastFishermanData = undefined;
gameController.fsWinnings = 0;
gameController.currentStake = 0;
gameController.muteCyclingWins = false;
gameController.finalFreeSpin = false;
gameController.skipWinsPressed = false;
gameController.totalWinnings = 0;
gameController.nudgeSoundPlayed = false;
gameController.gameAborted = false;
gameController.adjustedTopReels = [false, false, false, false, false];
gameController.adjustedReelContainerY = [0, 0, 0, 0, 0]; // Store container positions when reels adjusted
gameController.adjustedReelContainerX = [0, 0, 0, 0, 0];
gameController.adjustedReelFishermanPos = [null, null, null, null, null];
gameController.nudgeAnimationYAdjustment = [0, 0, 0, 0, 0]; // Per-reel Y adjustment for nudge animations
gameController.previousLayout = 'landscape_default'; // Track previous layout
gameController.isPrepaid = false;

// Fixed symbol data for starting symbols - always show the same symbols
gameController.startingCashPotOverrideData = {
  '0_2': { symbolId: 1 }, // Reel 0, Row 2: Jack symbol
  '2_2': { symbolId: 1 }, // Reel 2, Row 2: Jack symbol
};
gameController.displayingStartingSymbols = true; // Flag to track starting symbol display state

// Layout/positioning constants for orientation handling
const PORTRAIT_CONTAINER_Y = 230;
const ANIMATOR_Y_BASE_OFFSET = 151;
const ANIMATOR_Y_PORTRAIT_COMPENSATION = 236;
const BASE_ANIMATION_ADJUSTMENT = 156;
const SLAM_STOP_FISHERMAN_OFFSET = 120;
const LANDSCAPE_SLAM_STOP_ADJUSTMENT = -208;
const PORTRAIT_SLAM_STOP_ADJUSTMENT = -156;

//////////////////////////////////////////////////////
// Jamie - To control FS animation speeds
gameController.wildPanelParticleSpeedScaler = 2000;
gameController.mainReelsParticleSpeedScaler = 2000;
//////////////////////////////////////////////////////

gameController.setupWaterFilter = function () {
  let mapLandscape = resourceManager.get('mapWater');
  //mapLandscape.texture.baseTexture.wrapMode = PIXI.settings.WRAP_MODE.REPEAT;

  //let filterLandscape = new PIXI.filters.ReflectionFilter({
  //  mirror: false, // Toggle mirror effect
  //  boundary: 0.5, // Boundary point of the reflection (0 to 1)
  //  amplitude: [10, 20], // Wave amplitude [horizontal, vertical]
  //  waveLength: [30, 50], // Wave length [horizontal, vertical]
  //  alpha: 0.7, // Alpha transparency of the reflection
  //});

  let filterLandscape = new PIXI.filters.DisplacementFilter(mapLandscape, 70);

  let bg = resourceManager.get('gameBackground');
  bg.filters = [filterLandscape];

  //const widthLandscape = mapLandscape.width;

  gameController.filterLandscapeAnim = gsap.to(mapLandscape, {
    duration: 2,
    x: 100,
    ease: 'none',
    repeat: -1,
    yoyo: true,
  });

  //resourceManager.get('preReels').visible = false;
  //resourceManager.get('preReelsNudge').visible = false;
  //resourceManager.get('slotContainer').visible = false;
  //resourceManager.get('nudgeSlotContainer').visible = false;
  //resourceManager.get('postReels').visible = false;
  //resourceManager.get('postReelsNudge').visible = false;
};

gameController.fadeSound = function (soundsToFade, fadeTo, time, fadeIn) {
  timerManager.addTimer(
    time,
    function (progress) {
      soundsToFade.forEach(function (sound) {
        if (sound) {
          let fade = fadeTo * (1 - progress);
          if (fadeIn) {
            fade = fadeTo * progress;
          }
          soundManager.setVolume(fade, sound);
        }
      });
    },
    function () {
      soundsToFade.forEach(function (sound) {
        if (sound) {
          soundManager.setVolume(fadeTo, sound);
        }
      });
    }
  );
};

gameController.initialise = function () {
  gameController.rng = new RNG();

  gameController.bigWin = resourceManager.get('bigWin');
  gameController.bigWin.init();

  resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;

  const volumeButton = resourceManager.get('buttonContainer:buttonBar:mute');
  volumeButton.canShowBase = volumeButton.canShow;
  volumeButton.canShow = function () {
    return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
  };

  gameController.setupSlotAnimVisuals();

  gameController.fullScreenBubblesFront = resourceManager.get('risingBubblesFront');
  gameController.fullScreenBubblesBack = resourceManager.get('risingBubblesBack');

  const params = {
    scale: 0.2,
    startSpeed: 60,
    endSpeed: 40,
    lifetime: 6,
    frequency: 0.05,
    blend: 0,
    clear: true,
  };

  gameController.slotMachine = resourceManager.getController('SlotMachine');

  const reelNames = ['reel0', 'reel1', 'reel2', 'reel3', 'reel4'];
  gameController.slotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);

    gameController.playLandSounds(reel);

    gameController.stoppedReels[reel] = true;
    gameController.onSpinHit(reel);
  });

  gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    gameController.onSpinLand(reel);
  });

  for (let i = 0; i < 5; ++i) {
    let rv = resourceManager.get('slotContainer:reelContainer:reel' + i);

    rv.reassignSlotMachine(gameController.slotMachine);
  }

  gameController.slotMachine.selectReelMode('default');

  gameController.winlineAnimator = resourceManager.getSharedPlugin('WinlineAnimatorEx');

  const slamStopButton = resourceManager.get('buttonContainer:buttonBar:slamStopButton');
  slamStopButton.canEnableBase = slamStopButton.canEnable;
  slamStopButton.canEnable = function () {
    return this.canEnableBase() && gameController._receivedResponse;
  };

  // Setup nudge slot machine

  gameController.nudgeSlotMachine = resourceManager.getController('NudgeSlotMachine');

  const nudgeReelNames = ['reel0', 'reel1', 'reel2', 'reel3', 'reel4'];
  gameController.nudgeSlotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = nudgeReelNames.indexOf(reelId);

    gameController.playNudgeLandSounds(reel);
    gameController.stoppedReels[reel] = true;
    gameController.onNudgeSpinHit(reel);
  });

  gameController.nudgeSlotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = nudgeReelNames.indexOf(reelId);
    gameController.onNudgeSpinLand(reel);
  });

  for (let i = 0; i < 5; ++i) {
    let rv = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel' + i);
    let pos = {
      x: rv.x,
      y: rv.y,
    };
    gameController.nudgeReelPositions.push(pos);

    gameController.wildPanelMultipliers.push(0);

    rv.reassignSlotMachine(gameController.nudgeSlotMachine);
  }

  gameController.nudgeSlotMachine.selectReelMode('default');

  for (let i = 0; i < 5; i++) {
    resourceManager.get(`postReelsNudge:winnings:meter${i}`).visible = false;
    resourceManager.get(`postReelsNudge:winnings:frame${i}`).visible = false;
  }

  gameController.symbolLandAnimator = resourceManager.get('slotContainer:BonusLandAnimator');

  gameController.winControllerMain = resourceManager.getController('WinControllerMain');

  gameController.freeSpinsWildPanel = resourceManager.get('freeSpinsWildPanel');

  //gameController.scatterSymbolReels = [];
  //for (let i = 0; i < gameData.numReels; ++i) {
  //  const scatterReel = resourceManager.get('slotContainer:reelFrame:scatterReels:scatterReel' + i);
  //  gameController.scatterSymbolReels.push(scatterReel);
  //}

  //gameController.logo = resourceManager.get('logo');
  gameController.symbolOverlayDisplay = resourceManager.get('symbolOverlayDisplay');

  gameController.symbolAnimator = resourceManager.get('slotContainer:SymbolAnimator');

  gameController.nudgeSymbolAnimator = resourceManager.get('nudgeSlotContainer:nudgeAnimationContainer:SymbolAnimator');

  //if (gameController.inFreeSpins) {
  //  gameController.bg = resourceManager.get('fsbackground');
  //} else {
  //  gameController.bg = resourceManager.get('background');
  //}

  let nudgeSlotContainer = resourceManager.get('nudgeSlotContainer');
  let clipMask0 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:clipMask0');
  let clipMask1 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:clipMask1');
  let clipMask2 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:clipMask2');
  let clipMask3 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:clipMask3');
  let clipMask4 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:clipMask4');

  // Apply individual masks to each reel
  let reel0 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel0');
  let reel1 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel1');
  let reel2 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel2');
  let reel3 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel3');
  let reel4 = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel4');

  reel0.mask = clipMask0;
  reel1.mask = clipMask1;
  reel2.mask = clipMask2;
  reel3.mask = clipMask3;
  reel4.mask = clipMask4;

  // Pre-create a pool of reusable animation masks to avoid memory issues from repeated PIXI.Graphics creation
  gameController.animationMaskPool = [];
  for (let i = 0; i < 5; i++) {
    // Create 5 masks (one per reel maximum)
    const mask = new PIXI.Graphics();
    mask.beginFill(0xffffff);
    mask.drawRect(-75, -77.5, 150, 155); // 150x155 centered
    mask.endFill();
    mask._poolIndex = i;
    mask._isInUse = false;
    gameController.animationMaskPool.push(mask);
  }

  if (gameController.dynamicSpinner) {
    gameController.slotMachine.setDynamicSpinner(true);
    gameController.slotMachine.setInjectorMode('main');
    gameController.nudgeSlotMachine.setDynamicSpinner(true);
    gameController.nudgeSlotMachine.setInjectorMode('main');
  }

  gameController.animateBackgroundClouds();
  gameController.animateBackgroundSunRays();

  //gameController.onOrientationChange();

  musicManager.onGameLoaded();

  Reflex.registerEventHandler('orientationChange', gameController.onOrientationChange);

  //////////////////////////////////////////////////////////////////////
  // Jamie - could use these
  gameController.timeScale = 1;
  document.addEventListener('keydown', gameController.onKeyDown);

  //gameController.setupWaterFilter();
};

gameController.onKeyDown = function (event) {
  // if (event.key === '*') {
  //   gameController.timeScale *= 2;
  // } else if (event.key === '/') {
  //   gameController.timeScale /= 2;
  // } else if (event.key === '-') {
  //   gameController.timeScale = 1;
  // }
  // gameController.setTimeScale();
};

gameController.setTimeScale = function () {
  PIXI.ticker.shared.speed = gameController.timeScale;
  gsap.globalTimeline.timeScale(gameController.timeScale);
};

gameController.startReelAnticipation = function (reel, nudgeReel) {
  gameController.stopReelAnticipation();

  if (nudgeReel) {
    gameController.nudgeAnticipationEmitters[reel].emitter.particleEmitter.emit = true;
    gameController.nudgeAnticipationEmitters[reel].emitter.visible = true;

    if (gameController.nudgeAnticipationEmitters[reel].timeline) {
      gameController.nudgeAnticipationEmitters[reel].timeline.restart();
    }
  } else {
    gameController.mainAnticipationEmitters[reel].emitter.particleEmitter.emit = true;
    gameController.mainAnticipationEmitters[reel].emitter.visible = true;

    if (gameController.mainAnticipationEmitters[reel].timeline) {
      gameController.mainAnticipationEmitters[reel].timeline.restart();
    }
  }
};

gameController.stopReelAnticipation = function () {
  gameController.mainAnticipationEmitters.forEach((mainEmitter) => {
    mainEmitter.emitter.particleEmitter.emit = false;
    mainEmitter.emitter.visible = false;
    if (mainEmitter.timeline) {
      mainEmitter.timeline.pause();
    }
  });
  gameController.nudgeAnticipationEmitters.forEach((nudgeEmitter) => {
    nudgeEmitter.emitter.particleEmitter.emit = false;
    nudgeEmitter.emitter.visible = false;
    if (nudgeEmitter.timeline) {
      nudgeEmitter.timeline.pause();
    }
  });
};

gameController.setupSlotAnimVisuals = function () {
  for (var reel = 0; reel < 5; reel++) {
    var wildRowAnims = [];
    var symbolFrames = [];
    var nudgeArrowGraphics = [];

    let pos = helpers.getNudgeSymbolPos(reel);

    var nudgeSymbolGlowAnim = resourceManager.createObject(
      'movie',
      'nudgeSymbolGlow_' + reel,
      'particlesContainerFront',
      {
        definition: 'topHitSymbolGlow',
        anchor: 0.5,
        x: pos.x,
        y: pos.y,
        scale: 1,
        loop: true,
      }
    );
    nudgeSymbolGlowAnim.gotoAndStop(0);
    nudgeSymbolGlowAnim.visible = false;
    nudgeSymbolGlow = {
      anim: nudgeSymbolGlowAnim,
      active: false,
    };
    gameController.nudgeFrameGlows.push(nudgeSymbolGlow);

    for (var row = 0; row < 3; row++) {
      let pos = helpers.getSymbolPos(reel, row);

      var wild = resourceManager.createObject('movie', 'wildTransition' + reel + '_' + row, 'particlesContainerFront', {
        definition: 'wildTransition',
        x: 0,
        y: 0,
        anchor: 0.5,
        scale: 1,
        loop: false,
      });
      wild.gotoAndStop(0);
      wild.visible = false;
      wildRowAnims.push(wild);

      var symbolFrame = resourceManager.createObject(
        'movie',
        'symbolFrame' + reel + '_' + row,
        'particlesContainerFront',
        {
          definition: 'symbolFrame',
          x: pos.x,
          y: pos.y,
          anchor: 0.5,
          scale: 1.0,
          loop: false,
        }
      );
      symbolFrame.gotoAndStop(0);
      symbolFrames.push(symbolFrame);
    }
    gameController.wildTransitionAnims.push(wildRowAnims);
    gameController.symbolFramePanels.push(symbolFrames);

    for (var i = 0; i < gameController.nudgeArrowsPerReel; i++) {
      var arrow = resourceManager.createObject('sprite', 'arrow' + reel + '_' + i, 'arrowsContainer', {
        fileName: 'Base_Game/TH_Arrow_Nudge.png',
        x: 0,
        y: 0,
        anchor: 0.5,
        scale: 1.0,
      });
      arrow.visible = false;
      nudgeArrowGraphics.push(arrow);
    }
    gameController.nudgeArrows.push(nudgeArrowGraphics);

    let multiplierText = resourceManager.createObject('text', 'topReelmultiplier_' + reel, 'particlesContainerFront', {
      fontDefinition: 'topReelMultiplierAmount',
      anchor: 0.5,
      x: 0,
      y: 0,
      maxWidth: 100,
    });
    multiplierText.visible = false;
    gameController.topReelMultiplierText.push(multiplierText);
  }

  // Jamie - get these positions later correctly - needs to handle inherited positions
  for (let i = 0; i < 5; i++) {
    var fsWild = resourceManager.createObject('movie', 'fsWildTransition' + i, 'particlesContainerFront', {
      definition: 'wildTransition',
      x: 1195,
      y: 135 + i * 104,
      anchor: 0.5,
      scale: 0.57,
      loop: false,
    });
    fsWild.gotoAndStop(0);
    fsWild.visible = false;
    gameController.freeSpinsWildTransitions.push(fsWild);
  }

  gameController.extraSpinText = resourceManager.createObject('text', '', 'particlesContainerFront', {
    // Jamie - change font later - not sure what to use
    fontDefinition: 'Roboto_Slab_Extra_Bold_Gold_58',
    translationPhrase: 't_extraSpin',
    anchor: 0.5,
    x: 0,
    y: 0,
    maxWidth: 500,
  });
  gameController.extraSpinText.visible = false;

  gameController.spinningSparkle = resourceManager.createObject(
    'sprite',
    'spinningSparkle',
    'particlesContainerFront',
    {
      fileName: 'Pop_Up_Panels/Rays_Yellow.png',
      x: 0,
      y: 0,
      anchor: 0.5,
    }
  );
  gameController.spinningSparkle.visible = false;

  for (let i = 0; i < 5; i++) {
    let mainAnticipation = particleManager.createEmitter('anticipation', 'particlesContainerFront', 0, 0, false);
    mainAnticipation.particleEmitter.emit = false;
    mainAnticipation.visible = false;
    let mainAnticipationAnim = {
      emitter: mainAnticipation,
      timeline: undefined,
    };
    gameController.mainAnticipationEmitters.push(mainAnticipationAnim);

    let nudgeAnticipation = particleManager.createEmitter('anticipation', 'particlesContainerFront', 0, 0, false);
    nudgeAnticipation.particleEmitter.emit = false;
    nudgeAnticipation.visible = false;
    let nudgeAnticipationAnim = {
      emitter: nudgeAnticipation,
      timeline: undefined,
    };
    gameController.nudgeAnticipationEmitters.push(nudgeAnticipationAnim);
  }
  gameController.resetAnticipationEmitterPositions();

  // 15 emitters set up for bubble emitter pool, should be enough although we can add more if needed
  gameController.wildBubbleEmitterPool = [];

  for (let i = 0; i < 15; i++) {
    gameController.addNewWildBubbleEmitter();
  }
};

gameController.resetAnticipationEmitterPositions = function () {
  gameController.stopReelAnticipation();

  for (let i = 0; i < 5; i++) {
    //gameController.mainAnticipationEmitters[i].position = pos;
    //gameController.mainAnticipationEmitters[i].emitter.particleEmitter.updateOwnerPos(pos.x, pos.y);

    let xOffset = 78;
    let yOffset = 234;

    if (i < gameController.mainAnticipationEmitters.length) {
      let pos = helpers.getSymbolPos(i, 1);
      let mainEmitterSpawnPos = {
        x: pos.x + xOffset,
        y: pos.y - yOffset,
      };

      if (gameController.mainAnticipationEmitters[i].timeline) {
        gameController.mainAnticipationEmitters[i].timeline.clear();
      }

      gameController.mainAnticipationEmitters[i].timeline = gsap.timeline({
        repeat: -1,
        defaults: { ease: 'none' },
        paused: true,
      });

      let mainObject = gameController.mainAnticipationEmitters[i].emitter;
      mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
      mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;
      //mainObject.particleEmitter.updateOwnerPos(mainEmitterSpawnPos.x, mainEmitterSpawnPos.y);

      gameController.mainAnticipationEmitters[i].timeline
        .to(mainEmitterSpawnPos, {
          x: pos.x + xOffset,
          y: pos.y + yOffset,
          duration: 0.3,
          onUpdate: () => {
            mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
            mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;
            //mainObject.particleEmitter.updateOwnerPos(mainEmitterSpawnPos.x, mainEmitterSpawnPos.y);
          },
        })
        .to(mainEmitterSpawnPos, {
          x: pos.x - xOffset,
          y: pos.y + yOffset,
          duration: 0.1,
          onUpdate: () => {
            mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
            mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;
            //mainObject.particleEmitter.updateOwnerPos(mainEmitterSpawnPos.x, mainEmitterSpawnPos.y);
          },
        })
        .to(mainEmitterSpawnPos, {
          x: pos.x - xOffset,
          y: pos.y - yOffset,
          duration: 0.3,
          onUpdate: () => {
            mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
            mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;
            //mainObject.particleEmitter.updateOwnerPos(mainEmitterSpawnPos.x, mainEmitterSpawnPos.y);
          },
        })
        .to(mainEmitterSpawnPos, {
          x: pos.x + xOffset,
          y: pos.y - yOffset,
          duration: 0.1,
          onUpdate: () => {
            mainObject.particleEmitter.spawnPos.x = mainEmitterSpawnPos.x;
            mainObject.particleEmitter.spawnPos.y = mainEmitterSpawnPos.y;
            //mainObject.particleEmitter.updateOwnerPos(mainEmitterSpawnPos.x, mainEmitterSpawnPos.y);
          },
        });
    }

    if (i < gameController.nudgeAnticipationEmitters.length) {
      let nudgePos = helpers.getNudgeSymbolPos(i);
      //gameController.nudgeAnticipationEmitters[i].position = nudgePos;
      //gameController.nudgeAnticipationEmitters[i].emitter.particleEmitter.updateOwnerPos(nudgePos.x, nudgePos.y);
      if (gameController.nudgeAnticipationEmitters[i].timeline) {
        gameController.nudgeAnticipationEmitters[i].timeline.clear();
      }

      yOffset = 78;

      let nudgeEmitterSpawnPos = {
        x: nudgePos.x + xOffset,
        y: nudgePos.y - yOffset,
      };

      gameController.nudgeAnticipationEmitters[i].timeline = gsap.timeline({
        repeat: -1,
        defaults: { ease: 'none' },
        paused: true,
      });

      let nudgeObject = gameController.nudgeAnticipationEmitters[i].emitter;
      nudgeObject.particleEmitter.updateOwnerPos(nudgeEmitterSpawnPos.x, nudgeEmitterSpawnPos.y);

      gameController.nudgeAnticipationEmitters[i].timeline
        .to(nudgeEmitterSpawnPos, {
          x: nudgePos.x + xOffset,
          y: nudgePos.y + yOffset,
          duration: 0.1,
          onUpdate: () => {
            nudgeObject.particleEmitter.updateOwnerPos(nudgeEmitterSpawnPos.x, nudgeEmitterSpawnPos.y);
          },
        })
        .to(nudgeEmitterSpawnPos, {
          x: nudgePos.x - xOffset,
          y: nudgePos.y + yOffset,
          duration: 0.1,
          onUpdate: () => {
            nudgeObject.particleEmitter.updateOwnerPos(nudgeEmitterSpawnPos.x, nudgeEmitterSpawnPos.y);
          },
        })
        .to(nudgeEmitterSpawnPos, {
          x: nudgePos.x - xOffset,
          y: nudgePos.y - yOffset,
          duration: 0.1,
          onUpdate: () => {
            nudgeObject.particleEmitter.updateOwnerPos(nudgeEmitterSpawnPos.x, nudgeEmitterSpawnPos.y);
          },
        })
        .to(nudgeEmitterSpawnPos, {
          x: nudgePos.x + xOffset,
          y: nudgePos.y - yOffset,
          duration: 0.1,
          onUpdate: () => {
            nudgeObject.particleEmitter.updateOwnerPos(nudgeEmitterSpawnPos.x, nudgeEmitterSpawnPos.y);
          },
        });
    }
  }
};

gameController.addNewWildBubbleEmitter = function () {
  let bubbleAnim = particleManager.createEmitter('bubbles', 'particlesContainerFront', 0, 0, false);
  bubbleAnim.particleEmitter.emit = false;
  bubbleAnim.visible = false;

  let bubbleEmitter = {
    emitter: bubbleAnim,
    active: false,
    id: gameController.wildBubbleEmitterUniqueID,
  };
  gameController.wildBubbleEmitterUniqueID++;
  gameController.wildBubbleEmitterPool.push(bubbleEmitter);
};

gameController.getWildBubbleEmitter = function () {
  for (let i = 0; i < gameController.wildBubbleEmitterPool.length; i++) {
    if (!gameController.wildBubbleEmitterPool[i].active) {
      gameController.wildBubbleEmitterPool[i].active = true;
      return gameController.wildBubbleEmitterPool[i];
    }
  }
  // Need to create a new emitter
  gameController.addNewWildBubbleEmitter();
  return gameController.wildBubbleEmitterPool[gameController.wildBubbleEmitterPool.length - 1];
};

gameController.returnWildBubbleEmitter = function (id) {
  for (let i = 0; i < gameController.wildBubbleEmitterPool.length; i++) {
    if (gameController.wildBubbleEmitterPool[i].id === id) {
      gameController.wildBubbleEmitterPool[i].active = false;
      gameController.wildBubbleEmitterPool[i].emitter.particleEmitter.emit = false;
      gameController.wildBubbleEmitterPool[i].emitter.visible = false;
    }
  }
};

gameController.spinSparkle = function (position, scale, duration, completeCallback) {
  gameController.spinningSparkle.position = position;
  gameController.spinningSparkle.rotation = 0;
  gameController.spinningSparkle.scale.set(scale);

  gsap.to(gameController.spinningSparkle, {
    duration: duration / 2,
    rotation: Math.PI / 5,
    alpha: 1,
    ease: 'linear',
    onStart: () => {
      gameController.spinningSparkle.visible = true;
    },
    onComplete: () => {
      gsap.to(gameController.spinningSparkle, {
        duration: duration / 2,
        rotation: Math.PI / 5,
        alpha: 0,
        ease: 'linear',
        onComplete: () => {
          gameController.spinningSparkle.visible = true;
          completeCallback();
        },
      });
    },
  });
};

/**
 *
 * @returns
 *
 * Show whatever symbol we should ( 0, 1 or 2)
 * Then offset it on the reels?
 *
 */
gameController.offsetNudgeReels = function () {
  spinController.nudgeLandOffsets = [0, 0, 0, 0, 0];
  gameController.nudgeDirections = ['none', 'none', 'none', 'none', 'none'];

  let topReelSyms = gameController.getTopReelBeforeNudge();

  if (topReelSyms === undefined) {
    return;
  }

  let offset = 0;

  for (let i = 0; i < topReelSyms.length; i++) {
    if (
      // 1
      topReelSyms[i].symbols[0].value !== 17 &&
      topReelSyms[i].symbols[1].value === 17 &&
      topReelSyms[i].symbols[2].value === 17
    ) {
      offset = -(gameController.nudgeSectorSize * 2);
      gameController.nudgeDirections[i] = 'down';
    } else if (
      // 1, 2
      topReelSyms[i].symbols[0].value !== 17 &&
      topReelSyms[i].symbols[1].value !== 17 &&
      topReelSyms[i].symbols[2].value === 17
    ) {
      offset = -gameController.nudgeSectorSize;
      gameController.nudgeDirections[i] = 'down';
    } else if (
      // 2, 3
      topReelSyms[i].symbols[0].value === 17 &&
      topReelSyms[i].symbols[1].value !== 17 &&
      topReelSyms[i].symbols[2].value !== 17
    ) {
      offset = gameController.nudgeSectorSize;
      gameController.nudgeDirections[i] = 'up';
    } else if (
      // 3
      topReelSyms[i].symbols[0].value === 17 &&
      topReelSyms[i].symbols[1].value === 17 &&
      topReelSyms[i].symbols[2].value !== 17
    ) {
      offset = gameController.nudgeSectorSize * 2;
      gameController.nudgeDirections[i] = 'up';
    }

    spinController.nudgeLandOffsets[i] = offset;
    offset = 0;
  }
};

gameController.playNudgeLandSounds = function (reel) {
  soundManager.play('topReelStop');
};

gameController.playLandSounds = function (reel) {
  const id = soundManager.play('reelStop' + reel);
};

gameController.start = function () {
  gameController.stateMachine.switchState('WAITING_FOR_START');
};

gameController.shuffle = function (array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

gameController.onSpinComplete = function () {
  let upgradeOccurring = false;
  for (let i = 0; i < 4; i++) {
    if (gameController.wildPanelMultipliers[i] > 0) {
      upgradeOccurring = true;
      break;
    }
  }

  if (upgradeOccurring && gameController.inFreeSpins) {
    timerManager.addTimeout(1000, function () {
      gameController.updatePersistantWilds();
    });
  } else {
    gameController.updatePersistantWilds();
  }

  gameController.spinComplete = true;
  gameController._receivedResponse = true;
  gameController.slamStopped = false;
  soundManager.stop('reelspin');
  gameController.stateMachine.switchState('WAITING_FOR_REELS');
};

gameController.updatePersistantWilds = function () {
  // Jamie - similar thing happens during wild transition - refactor when updating
  let upgradeOccured = false;
  if (gameController.inFreeSpins) {
    for (let reel = 0; reel < 5; reel++) {
      let reelObject = gameData.reels[reel];

      for (let row = 0; row < 3; row++) {
        let symID = gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value;

        // Jamie - Grrrr - this is a mess
        if (symID >= 5 && symID <= 8) {
          let multiIndex = 0;
          if (symID === 8) {
            multiIndex = 0;
          } else if (symID === 7) {
            multiIndex = 1;
          } else if (symID === 6) {
            multiIndex = 2;
          } else if (symID === 5) {
            multiIndex = 3;
          }
          if (gameController.wildPanelMultipliers[multiIndex] > 0) {
            let wildSymID = gameController.wildPanelMultipliers[multiIndex] + 9;

            timerManager.addTimeout(200, function () {
              reelObject.setReelSymbol(row, wildSymID);
            });
            let mainReelScaleX = resourceManager.get('slotContainer').scale.x;
            let mainReelScaleY = resourceManager.get('slotContainer').scale.y;
            gameController.wildTransitionAnims[reel][row].scale.set(mainReelScaleX, mainReelScaleY);
            gameController.wildTransitionAnims[reel][row].position = helpers.getSymbolPos(reel, row);
            gameController.wildTransitionAnims[reel][row].visible = true;
            gameController.wildTransitionAnims[reel][row].gotoAndPlay(0);
            upgradeOccured = true;
          }
        }
      }
    }
  }
  if (upgradeOccured) {
    soundManager.play(soundManifest.getSound('zapLanding'));
  }
};

gameController.getFishData = function () {
  return gameController.fishData;
};

gameController.getFishSpinningPastData = function () {
  // return an object with absolute value to display on the fish
  // and the symbol id to display
  // { value: 100, symbolId: 18 }
  // Jamie - later hook this up with weighting data obtained from server

  let stake = gameController.getCurrentModeStake(true);
  spinningFishData = {};
  let randomfish = Math.floor(Math.random() * 6);

  if (randomfish === 0) {
    spinningFishData = { value: 1 * stake, symbolId: 18 }; // Bronze pot
  } else if (randomfish === 1) {
    spinningFishData = { value: 3 * stake, symbolId: 19 }; // Silver pot 1
  } else if (randomfish === 2) {
    spinningFishData = { value: 5 * stake, symbolId: 20 }; // Silver pot 2
  } else if (randomfish === 3) {
    spinningFishData = { value: 8 * stake, symbolId: 21 }; // Gold pot 1
  } else if (randomfish === 4) {
    spinningFishData = { value: 15 * stake, symbolId: 22 }; // Gold pot 2
  } else if (randomfish === 5) {
    spinningFishData = { value: 25 * stake, symbolId: 23 }; // Gold pot 3
  }
  return spinningFishData;
};

gameController.getStartingCashPotOverrideData = function (reel, row) {
  const key = `${reel}_${row}`;
  const fixedData = gameController.startingCashPotOverrideData[key];

  if (fixedData) {
    return {
      symbolId: fixedData.symbolId,
      value: fixedData.value,
    };
  }
  return null;
};

gameController.getIsRecovery = function () {
  return gameController.inRecovery;
};

gameController.onNudgeSpinComplete = function () {
  soundManager.stop('topReelSpin');
  gameController.nudgeSpinComplete = true;

  if (gameController.isTopHitReelNudged) {
    timerManager.addTimeout(500, function () {
      gameController.animateTopReelNudge(); // Slight delay to nudge start if needed
    });
  } else {
    gameController.nudgeHasFinished = true;
  }
};

gameController.animateTopReelNudge = function () {
  for (let reel = 0; reel < spinController.nudgeLandOffsets.length; reel++) {
    const nudgeSym = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel' + reel);

    // Spinner has already stored the nudge offset
    // so just specify the duration to nudge back
    if (gameController.nudgeAllowedOnReel[reel]) {
      nudgeSym.performNudge(1.5);
    }
  }
  gameController.animateNudgeArrows();

  timerManager.addTimeout(1500, function () {
    gameController.nudgeHasFinished = true;
  });
};

gameController.animateNudgeArrows = function () {
  gameController.arrowAnimsCount = 0;
  gameController.arrowAnimsComplete = 0;
  soundManager.play('nudgeTopReel');

  if (gameController.isTopHitReelNudged) {
    let animTime = 0.8;
    let arrowTimeOffset = 0.4;

    for (let reel = 0; reel < gameController.nudgeDirections.length; reel++) {
      if (gameController.nudgeDirections[reel] !== 'none' && gameController.nudgeAllowedOnReel[reel]) {
        for (let i = 0; i < gameController.nudgeArrowsPerReel; i++) {
          let arrow = gameController.nudgeArrows[reel][i];
          arrow.visible = true;
          arrow.alpha = 0;
          let symPos = helpers.getNudgeSymbolPos(reel);
          let shiftAmount = 300;
          arrow.x = symPos.x;
          arrow.y = symPos.y + shiftAmount / 2;
          gameController.arrowAnimsCount++;
          if (gameController.nudgeDirections[reel] === 'down') {
            arrow.scale.y = -1;
            arrow.y -= shiftAmount;
            shiftAmount *= -1;
          }
          gsap.to(arrow, {
            duration: animTime,
            y: '-=' + shiftAmount,
            delay: i * arrowTimeOffset,
          });
          gsap.to(arrow, {
            duration: animTime / 2,
            alpha: 0.5,
            delay: i * arrowTimeOffset,
          });
          gsap.to(arrow, {
            duration: animTime / 2,
            alpha: 0,
            delay: animTime / 2 + i * arrowTimeOffset,
            onComplete: function () {
              gameController.arrowAnimsComplete++;

              if (gameController.nudgeDirections[reel] === 'down') {
                arrow.scale.y = 1;
              }
            },
          });
        }
      }
    }
  }
};

gameController.playTopReelBonusAnimations = function () {
  let symbols = [];
  for (let i = 0; i < gameController.fullSymbolsOnTopHitReel.length; i++) {
    if (gameController.fullSymbolsOnTopHitReel[i] === 15) {
      symbols.push({ cell: { reel: i, row: 1 }, symbolId: 15 });
    }
  }

  if (symbols.length > 0) {
    let landIndex = gameController.bonusSymbolsLanded;
    if (landIndex >= 5) {
      landIndex = 4;
    }
    soundManager.play('bonusLand' + landIndex);
    gameController.bonusSymbolsLanded++;
  }

  // Reset container Y and per-reel adjustments
  gameController.nudgeSymbolAnimator.y = 0;
  gameController.nudgeAnimationYAdjustment = [0, 0, 0, 0, 0];

  // Set per-reel Y adjustments for symbols on adjusted reels
  // Previously we were moving the whole container which could cause issues if
  // multiple reels were adjusted differently
  for (let i = 0; i < symbols.length; i++) {
    const reelIndex = symbols[i].cell.reel;
    const needsAdjustment =
      gameController.adjustedTopReels[reelIndex] ||
      (gameController.slamStopped && gameController.nudgeDirections[reelIndex] === 'down');

    if (needsAdjustment) {
      let adjustment = ANIMATOR_Y_BASE_OFFSET;
      if (layoutController.getCurrentLayout() === 'portrait_default') {
        adjustment += ANIMATOR_Y_PORTRAIT_COMPENSATION - PORTRAIT_CONTAINER_Y;
      }
      gameController.nudgeAnimationYAdjustment[reelIndex] = adjustment;
    }
  }

  gameController.nudgeSymbolAnimator.animateSymbols(
    symbols,
    gameController.nudgeSlotMachine,
    true,
    false,
    function () {},
    function () {}
  );
};

gameController.playMainReelBonusAnimations = function () {
  let symbolsToAnimate = [];
  let bonusSymbolFound = false;

  for (let reel = 0; reel < gameController.spinTask.data.resultPanel.reelList.length; ++reel) {
    for (let row = 0; row < gameController.spinTask.data.resultPanel.reelList[reel].symbols.length; ++row) {
      // Bonus symbol
      if (gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === 15) {
        found = {
          row,
          id: gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value,
        };
        let symData = {
          cell: { reel: reel, row: found.row },
          symbolId: found.id,
        };
        symbolsToAnimate.push(symData);
        bonusSymbolFound = true;
      }
    }
  }

  if (symbolsToAnimate.length > 0) {
    gameController.symbolLandAnimator.animateSymbols(
      symbolsToAnimate,
      gameController.slotMachine,
      function () {},
      true
    );
  }
};

gameController.startNudgeFrameGlow = function (reelIndex) {
  gameController.nudgeFrameGlows[reelIndex].anim.position = helpers.getNudgeSymbolPos(reelIndex);
  // If this reel was adjusted for the slam stop offset, move the glow down too
  if (gameController.adjustedTopReels[reelIndex]) {
    gameController.nudgeFrameGlows[reelIndex].anim.position.y += SLAM_STOP_FISHERMAN_OFFSET;
  }
  gameController.nudgeFrameGlows[reelIndex].anim.alpha = 0;
  gameController.nudgeFrameGlows[reelIndex].anim.visible = true;
  gameController.nudgeFrameGlows[reelIndex].anim.gotoAndPlay(0);
  gameController.nudgeFrameGlows[reelIndex].active = true;

  if (gameController.inFreeSpins) {
    soundManager.play('topReelHighlightFS');
  } else {
    soundManager.play('topReelHighlight');
  }

  timerManager.addTimeout(100, function () {
    soundManager.play(soundManifest.getSound('zapOverlay'));
  });

  timerManager.addTimeout(100, function () {
    soundManager.play(soundManifest.getSound('zapStart'));
  });

  timerManager.addTimer(
    100,
    function (progress) {
      gameController.nudgeFrameGlows[reelIndex].anim.alpha = progress;
    },
    function () {
      gameController.nudgeFrameGlows[reelIndex].anim.alpha = 1;
    }
  );
};

gameController.startNudgeFrameGlows = function () {
  let introTime = 0;

  this.playTopReelBonusAnimations();

  for (let i = 0; i < gameController.nudgeFrameGlows.length; i++) {
    if (gameController.nudgeFrameGlows[i].active) {
      gameController.startNudgeFrameGlow(i);
      introTime = 200;
    }
  }

  timerManager.addTimeout(introTime, function () {
    gameController.nudgeGlowIntroComplete = true;
  });
};

gameController.stopNudgeFrameGlow = function (reelIndex) {
  if (gameController.nudgeFrameGlows[reelIndex].active) {
    timerManager.addTimer(
      100,
      function (progress) {
        gameController.nudgeFrameGlows[reelIndex].anim.alpha = 1 - progress;
      },
      function () {
        gameController.nudgeFrameGlows[reelIndex].anim.gotoAndStop(0);
        gameController.nudgeFrameGlows[reelIndex].active = false;
        gameController.nudgeFrameGlows[reelIndex].anim.visible = false;
        gameController.nudgeFrameGlows[reelIndex].anim.alpha = 1;
      }
    );
  }
};

gameController.stopNudgeFrameGlows = function () {
  for (let i = 0; i < gameController.nudgeFrameGlows.length; i++) {
    gameController.stopNudgeFrameGlow(i);
  }
};

gameController.getTopReelBeforeNudge = function () {
  if (gameController.topHitReelBeforeNudge !== undefined) {
    return gameController.topHitReelBeforeNudge;
  }
};

gameController.animateFSSpinSymbolLand = function (reel) {};

gameController.animateFSSpinSymbolWin = function (reel, callback) {};

gameController.isBonusThisSpin = function () {
  let bonusCount = 0;
  for (let i = 0; i < gameData.numReels; i++) {
    bonusCount += gameController.countBonusOnReel(i);
  }
  return bonusCount >= gameController.minBonusForFeature;
};

gameController.isBonusPossible = function (reel) {
  switch (reel) {
    case 0: {
      return true;
    }
    case 1: {
      return gameController.bonusSymbolsLanded !== 0;
    }
    case 2: {
      return gameController.bonusSymbolsLanded >= 2;
    }
    case 3: {
      return gameController.bonusSymbolsLanded >= 2;
    }
    case 4: {
      return gameController.bonusSymbolsLanded >= 3;
    }
  }
};

// gameController.stopCloudAnimation() {
//
// }

gameController.animateBackgroundClouds = function () {
  // Animate clouds
  cloudStripOne = resourceManager.get('Cloud1');
  cloudStripTwo = resourceManager.get('Cloud2');
  cloudStripOneFS = resourceManager.get('Cloud1FS');
  cloudStripTwoFS = resourceManager.get('Cloud2FS');

  let position1 = cloudStripOne.position.getX();
  gsap.fromTo(
    cloudStripOne,
    {
      x: position1,
    },
    {
      delay: 0,
      duration: 100,
      ease: 'none',
      x: cloudStripOne.position.getX() - 1280,
      yoyo: false,
      repeat: -1,
    }
  );

  let position2 = cloudStripTwo.position.getX();
  gsap.fromTo(
    cloudStripTwo,
    {
      x: position2,
    },
    {
      delay: 0,
      duration: 100,
      ease: 'none',
      x: cloudStripTwo.position.getX() - 1280,
      yoyo: false,
      repeat: -1,
    }
  );

  let position1FS = cloudStripOneFS.position.getX();
  gsap.fromTo(
    cloudStripOneFS,
    {
      x: position1FS,
    },
    {
      delay: 0,
      duration: 100,
      ease: 'none',
      x: cloudStripOneFS.position.getX() - 1280,
      yoyo: false,
      repeat: -1,
    }
  );

  let position2FS = cloudStripTwoFS.position.getX();
  gsap.fromTo(
    cloudStripTwoFS,
    {
      x: position2FS,
    },
    {
      delay: 0,
      duration: 100,
      ease: 'none',
      x: cloudStripTwoFS.position.getX() - 1280,
      yoyo: false,
      repeat: -1,
    }
  );
};

gameController.animateBackgroundSunRays = function () {
  let bigSunRays = resourceManager.get('BigSunRays');
  bigSunRays.anchor.set(0.5);
  gsap.to(bigSunRays, {
    rotation: Math.PI,
    duration: 13.33,
    ease: 'none',
    repeat: -1,
  });

  let smallSunRays = resourceManager.get('SmallSunRays');
  smallSunRays.anchor.set(0.5);
  gsap.to(smallSunRays, {
    rotation: Math.PI,
    duration: 20,
    ease: 'none',
    repeat: -1,
  });
};

gameController.countSymbolOnReel = function (reel, symbolString) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultsPanel.reelList[reel].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }

  const symbols = resourceManager.getConfiguration().symbols;
  const found = reelSymbols.find(function (symbol) {
    return symbol.value === symbols[symbolString].ID;
  });

  if (found !== undefined) {
    return 1;
  } else {
    return 0;
  }
};

gameController.countBonusOnReel = function (reel) {
  return (
    gameController.countSymbolOnReel(reel, 'FS') +
    gameController.countSymbolOnReel(reel, 'FSS') +
    gameController.countSymbolOnReel(reel, 'FSM')
  );
};

gameController.countLogoOnReel = function (reel) {
  return gameController.countSymbolOnReel(reel, 'Logo');
};

gameController.onSpinLand = function (reel) {
  let bonusSyms = [];

  for (let row = 0; row < 3; row++) {
    let symID = gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value;
    // Jamie - Grrrr - this is a mess
    if (symID === 15) {
      let symData = {
        cell: {
          reel: reel,
          row: row,
        },
      };
      bonusSyms.push(symData);
    }
  }
  if (bonusSyms.length > 0) {
    gameController.symbolOverlayDisplay.addBonusOverlays(bonusSyms);
  }
};

gameController.onNudgeSpinLand = function (reel) {};

gameController.onSpinHit = function (reel) {
  gameController.landedReels[reel] = true;
  const bonusPossible = gameController.isBonusPossible(reel);
  let fsBonusPossible =
    gameController.bonusSymbolsLanded >= gameController.minBonusForFeature - 1 && bonusPossible && reel === 3;

  if (gameController.inBuyABonus && !gameController.inFreeSpins) {
    if (reel === 1 || reel === 3) {
      fsBonusPossible = true;
    } else {
      fsBonusPossible = false;
    }
  }

  if (fsBonusPossible && reel < gameData.numReels - 1) {
    gameController.canSlamStop = false;
  }
  if (!fsBonusPossible || reel === gameData.numReels - 1) {
    if (reel < gameData.numReels - 1) {
      // gameController.scatterSymbolReels.forEach(function(scatterReel){
      //     scatterReel.onStopScatterAnims();
      // });
    }
  }

  let found = undefined;
  let symbolsToAnimate = [];
  let bonusSymbolFound = false;
  let nudgeSymbolFound = false;
  let cashPotFound = false;

  for (let row = 0; row < gameController.spinTask.data.resultPanel.reelList[reel].symbols.length; ++row) {
    // Bonus symbol
    if (gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === 15) {
      found = {
        row,
        id: gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value,
      };
      let symData = {
        cell: { reel: reel, row: found.row },
        symbolId: found.id,
      };
      symbolsToAnimate.push(symData);
      bonusSymbolFound = true;
    }
    // Nudge symbol
    if (gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === 16) {
      found = {
        row,
        id: gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value,
      };
      let symData = {
        cell: { reel: reel, row: found.row },
        symbolId: found.id,
      };
      symbolsToAnimate.push(symData);
      nudgeSymbolFound = true;
    }
    // Cash Pot symbol
    if ([18, 19, 20, 21, 22, 23].includes(gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value)) {
      cashPotFound = true;
    }
  }

  if (cashPotFound) {
    soundManager.play(soundManifest.getSound('cashPotLand'));
  }

  if (nudgeSymbolFound && !gameController.nudgeSoundPlayed) {
    gameController.nudgeSoundPlayed = true;
    soundManager.play('nudgeSymbolLand');
  }

  if (bonusSymbolFound) {
    let landIndex = gameController.bonusSymbolsLanded;
    if (landIndex >= 5) {
      landIndex = 4;
    }
    soundManager.play('bonusLand' + landIndex);
    gameController.bonusSymbolsLanded++;
  }

  if (symbolsToAnimate.length > 0) {
    gameController.symbolLandAnimator.animateSymbols(
      symbolsToAnimate,
      gameController.slotMachine,
      function () {},
      true
    );
  }

  // if(bonusPossible) {
  //     let found = undefined;
  //     for (let row = 0; row < gameController.spinTask.data.resultPanel.reelList[reel].symbols.length; ++row) {
  //         if (gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symbols["FS"].ID ||
  //             gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symbols["FSS"].ID ||
  //             gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symbols["FSM"].ID) {
  //             found = {row,id:gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value};
  //             break;
  //         }
  //     }

  //     if (found !== undefined) {
  //         let symbolData = {
  //             cell: {reel: reel, row: found.row},
  //             symbolId: found.id
  //         };
  //         gameController.symbolLandAnimator.animateSymbols([symbolData], gameController.slotMachine, function () {

  //         });
  //     }
  // }

  gameData.reelsSpinning--;

  ////////////////////////////////////////////////////////////////////////////////////////
  // New Anticipation System here - might need to remove some of the above
  if (reel <= 3) {
    // Don't need to look ahead for the last reel
    let nextReel = reel + 1;
    if (spinController.longSpinMainReels[nextReel] === true) {
      gameController.startReelAnticipation(nextReel, false);
      if (!gameController.mainReelAnticipationSoundStarted) {
        if (!gameController.slamStopped) {
          soundManager.play('reelAnticipation');
        }
        gameController.mainReelAnticipationSoundStarted = true;
      }
    }
  } else if (reel === 4) {
    // Yeah bit of a hack to start the first anticipation on nudge reels
    if (spinController.longSpinNudgeReels[0] === true) {
      gameController.startReelAnticipation(0, true);
      if (!gameController.nudgeReelAnticipationSoundStarted) {
        if (!gameController.slamStopped) {
          soundManager.play('topReelAnticipation');
        }
        gameController.nudgeReelAnticipationSoundStarted = true;
      }
    }
  }
};

gameController.onNudgeSpinHit = function (reel) {
  gameData.nudgeReelsSpinning--;

  // If Leprechaun lands on the top reel, in freespins
  if (gameController.inFreeSpins && gameController.fullSymbolsOnTopHitReel[reel] === 9) {
    // Found a Leprechaun symbol
    soundManager.play('topLeprechaunLand', () => {
      soundManager.play('topLeprechaunLandHighlight');
    });
  }

  if (gameData.nudgeReelsSpinning === 0) {
    soundManager.stop('topReelSpin');
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  // New Anticipation System here - might need to remove some of the above
  if (reel <= 3) {
    // Don't need to look ahead for the last reel
    let nextReel = reel + 1;
    if (spinController.longSpinNudgeReels[nextReel] === true) {
      gameController.startReelAnticipation(nextReel, true);
      if (!gameController.nudgeReelAnticipationSoundStarted) {
        if (!gameController.slamStopped) {
          soundManager.play('topReelAnticipation');
        }
        gameController.nudgeReelAnticipationSoundStarted = true;
      }
    }
  } else if (reel === 4) {
    gameController.stopReelAnticipation();
  }
};

// make sure reels are back in their default y positions after potentially
// being moved after offset adjustments
gameController.resetReels = function () {
  for (let i = 0; i < 5; i++) {
    if (!gameController.adjustedTopReels[i]) {
      // Reel wasn't adjusted - do normal instant reset
      let nudgeReel = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel' + i);
      nudgeReel.y = gameController.nudgeReelPositions[i].y;
    }
  }
};

gameController.doSpin = function (spinTask) {
  gameController.stateMachine.switchState('SPIN_REELS_SPINNING');

  // Reset adjustment flags
  gameController.adjustedTopReels = [false, false, false, false, false];
  gameController.adjustedReelContainerY = [0, 0, 0, 0, 0];
  gameController.adjustedReelContainerX = [0, 0, 0, 0, 0];
  gameController.adjustedReelFishermanPos = [null, null, null, null, null];
  gameController.nudgeAnimationYAdjustment = [0, 0, 0, 0, 0];

  gameController.stopNudgeFrameGlows();

  gameController._receivedResponse = true;
  gameController.skipWinsPressed = false;

  gameController.isPrepaid = spinTask.data.isPrePaidGame;

  gameData.reelsSpinning = 5;

  gameData.nudgeReelsSpinning = 5;

  gameController.logoSymbolAnticipationReel = -1;

  gameController.longSpinReels = [false, false, false, false, false];

  gameController.finalFreeSpin = spinTask.data.finalFreeSpin;

  if (gameController.inBuyABonus && gameController.inBuyABonusFirstSpin) {
    gameController.slotMachine.setInjectorMode('buybonustriggerspin');
    gameController.longSpinReels = [false, false, true, false, true];
    gameController.inBuyABonusFirstSpin = false;
  }

  if (spinTask.data.localRng) {
    gameController.rng.seed(spinTask.data.localRng);
  }

  // Set up data for the reels
  let symbols = [];
  let above = [];
  let below = [];
  for (let reel = 0; reel < spinTask.data.resultPanel.reelList.length; reel++) {
    symbols.push([]);
    above.push([]);
    below.push([]);
    for (let row = 0; row < spinTask.data.resultPanel.reelList[reel].symbols.length; row++) {
      symbols[reel].push(spinTask.data.resultPanel.reelList[reel].symbols[row].value);
    }
  }

  gameData.spinData = spinTask.data;
  gameController.spinTask = spinTask;
  gameController.spinTask.join();

  // Start nudge reels

  gameController.nudgeAllowedOnReel = [false, false, false, false, false];

  gameController.isTopHitReelNudged = spinTask.data.isTopHitReelNudged;
  gameController.symbolReelsToNudge = spinTask.data.symbolReelsToNudge;

  for (let i = 0; i < gameController.symbolReelsToNudge.length; i++) {
    gameController.nudgeAllowedOnReel[gameController.symbolReelsToNudge[i]] = true;
  }

  gameController.topHitReelAfterNudge = spinTask.data.topHitReelAfterNudge.reelList;

  gameController.topHitReelBeforeNudge = spinTask.data.nudgeResultPanel.reelList;

  gameController.bonuses = spinTask.data.bonuses;

  gameController.fishData = spinTask.data.fishData;

  gameController.fishWinAmount = spinTask.data.fishWinAmount;

  gameController.fullSymbolsOnTopHitReel = spinTask.data.fullSymbolsOnTopHitReel;

  let topHitSymbolsInView = [];

  for (let reel = 0; reel < gameController.topHitReelBeforeNudge.length; reel++) {
    topHitSymbolsInView.push(17);
    for (let row = 0; row < gameController.topHitReelBeforeNudge[reel].symbols.length; row++) {
      if (gameController.topHitReelBeforeNudge[reel].symbols[row].value !== 17) {
        topHitSymbolsInView[reel] = gameController.topHitReelBeforeNudge[reel].symbols[row].value;
      }
    }
  }

  let nudgeSymbols = [];
  let nudgeSymbolsAbove = [];
  let nudgeSymbolsBelow = [];

  for (let reel = 0; reel < spinTask.data.nudgeResultPanel.reelList.length; reel++) {
    nudgeSymbols.push([]);
    nudgeSymbolsAbove.push([17]);
    nudgeSymbolsBelow.push([17]);
    for (let row = 0; row < spinTask.data.nudgeResultPanel.reelList[reel].symbols.length; row++) {
      if (row === 0 || row === 2) {
        nudgeSymbols[reel].push(17);
      } else {
        nudgeSymbols[reel].push(topHitSymbolsInView[reel]);
      }
    }
  }

  gameController.offsetNudgeReels();

  if (gameController.dynamicSpinner) {
    spinController.stopSpin(
      symbols,
      above,
      below,
      gameController.onSpinComplete,
      nudgeSymbols,
      nudgeSymbolsAbove,
      nudgeSymbolsBelow,
      gameController.onNudgeSpinComplete,
      gameController.topHitReelBeforeNudge
    );
  } else {
    gameController.slotMachine.stopReels(symbols, above, below, gameController.onSpinComplete);
    gameController.nudgeSlotMachine.stopReels(
      nudgeSymbols,
      nudgeSymbolsAbove,
      nudgeSymbolsBelow,
      gameController.onNudgeSpinComplete,
      undefined,
      gameController.topHitReelBeforeNudge
    );
  }
};

gameController.initNewSpin = function () {
  gameController.gameAborted = false;
  gameController.displayingStartingSymbols = false;
  musicManager.onGameStart();

  // Hide lucky bet message immediately when spin starts
  let luckyBetButton = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');
  if (luckyBetButton && luckyBetButton.hideLuckyBetMessage) {
    luckyBetButton.hideLuckyBetMessage();
  }

  if (!gameController.inFreeSpins) {
    gameController.lastFishermanData = undefined;
  }

  //hide overlays once reels are spinning.
  timerManager.addTimeout(400, function () {
    if (gameController.symbolOverlayDisplay && !gameController.slamStopped && !gameController.spinComplete) {
      gameController.symbolOverlayDisplay.hideAllBonusOverlays();

      if (!gameController.inFreeSpins && !autoplayManager.isAutoplayEnabled()) {
        if (!gameController.gameAborted) {
          gameController.currentReelSpin = soundManager.play('reelSpin');
          soundManager.play('topReelSpin');
        }
      }
    }
  });

  // reset reels once reels are well and truely spinning
  gameController.resetReelsTimer = timerManager.addTimeout(1000, function () {
    gameController.resetReels();
  });

  if (gameController.lastFishermanData !== undefined) {
    let fishermanPos = gameController.lastFishermanData.pos;
    let reel = gameController.lastFishermanData.reel;
    gameController.animateMultiplierIncrease(fishermanPos, reel);
    gameController.lastFishermanData = undefined;
  }

  gameController._receivedResponse = false;

  gameController.canSlamStop = true;
  gameController.slamStopped = false;
  gameController.bonusSymbolsLanded = 0;
  gameController.waitingForLandAnim = false;
  gameController.cyclingWins = false;
  gameController.bigWin._newSpin = true;
  gameData.winningsText.skip();
  gameController.nudgeSoundPlayed = false;
  //winlineAnimationController.skipAnimations();
  gameController.bigWin._newSpin = false;
  gameController.lastPayWinsData = undefined;
  gameController.spinComplete = false;
  gameController.nudgeSpinComplete = false;

  // gameController.winningsContainer.visible = false;
  if (!gameController.inFreeSpins) {
    gameData.winningsMeter.set(0);
    gameController.totalWinnings = 0;
  }

  timerManager.stop(gameController.timerFadeSpinsLoopIntoIdle);
  if (gameController.currentReelSpin !== undefined) {
    soundManager.stop(gameController.currentReelSpin);
  }
  gameController.symbolAnimator.skip();
  gameController.symbolLandAnimator.skip();

  gameController.stoppedReels = [false, false, false, false, false];
  gameController.landedReels = [false, false, false, false, false];

  gameController.spinHasMushroomPrizes = false;

  // Reset reel positions - skip reset for adjusted reels to avoid jump
  for (let i = 0; i < 5; i++) {
    if (!gameController.adjustedTopReels[i]) {
      // Reel wasn't adjusted - do normal instant reset
      let targetY = gameController.nudgeReelPositions[i].y;
      resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel' + i).y = targetY;
    }
    // If reel was adjusted, skip reset - let spin handle the position naturally
  }

  if (gameController.dynamicSpinner) {
    spinController.startSpin();
  } else {
    gameController.slotMachine.infiniteSpin();
    gameController.nudgeSlotMachine.infiniteSpin();
  }

  gameController.fishermanCashValues = [];

  for (let i = 0; i < 5; i++) {
    resourceManager.get(`postReelsNudge:winnings:meter${i}`).visible = false;
    resourceManager.get(`postReelsNudge:winnings:meter${i}`).scale.set(1);
    resourceManager.get(`postReelsNudge:winnings:frame${i}`).visible = false;

    gameController.fishermanCashValues.push(0);

    //for (let j = 0; j < 3; j++) {
    //  resourceManager.get(
    //    `slotContainer:reelContainer:reel${i}:symbol${j}:symbol:childContainer:cashOverlay:reel${i}:row${j}`
    //  ).alpha = 1.0;
    //}
  }

  gameController.slotMachine.dimAllSymbols(false, 0.1);

  gameController.setState_WaitingForServer();
  gameController.featurePrize = 0;
  gameController.reelsPrize = 0;
};

gameController.initNewGame = function () {
  gameController.stopCyclingWins();
  gameController.muteCyclingWins = false;

  gameController.inBuyABonus = false;
  gameController.inBuyABonusFirstSpin = true;
  gameController.preFSReelPrize = 0;
  gameController.stateMachine.switchState('GAME_PLAYING');
  gameController.slotMachine.selectReelMode('default');
  gameController.nudgeSlotMachine.selectReelMode('default');

  gameController.initNewSpin();

  if (autoplayManager.isAutoplayEnabled()) {
    resourceManager
      .getController('inputOverlord')
      .setText('autoplayCancelButton', String(autoplayManager.getRemainingRounds() - 1));
  }
};

gameController.startGame = function () {
  // Do not allow the user to spin if the buy bonus or autoplay dialog is visible
  let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');
  let autoplayPopUp = resourceManager.get('autoplayContainer:autoplayBacker');

  if (buyBonusPopUp.visible || autoplayPopUp.visible) return;

  gameController.justHadFreeSpins = false;

  gameController.initNewGame();

  const stakeController = resourceManager.getController('stakeController');
  let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

  gdk.startGame(
    {
      stake: stakeController.CurrentStake,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        buyABonus: false,
        encore: gameData.encoreEnabled,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

gameController.stopCyclingWins = function () {
  gameController.cyclingWins = false;
  gameController.symbolAnimator.skip();
  gameController.lastPayWinsData = undefined;
  gameController.winlineAnimator.skipAnimation();
  gameController.winlineAnimator.clearWinlines();
  gameController.cyclingWinsIndex = 0;
  gameController.stopSymbolFrameDisplay();
};

gameController.setState_WaitingForServer = function (eventToLeave) {
  if (!gameController.inFreespins) {
    // Only monitor how long we are waiting for server if we arent in freespins
    gameController.stateMachine.switchState('WAITING_FOR_SERVER');
  }
  if (checkForDefined(eventToLeave)) {
    eventToLeave.leave();
  }
};

gameController.checkForSymbolOnFullReels = function (symbol) {
  for (let reel = 0; reel < 5; reel++) {
    for (let row = 0; row < 3; row++) {
      if (gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symbol) {
        return true;
      }
    }
  }
  return false;
};

gameController.autoplayStarted = function (autoplayData) {
  autoplayManager.dialog.buttonGlow = resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow');

  autoplayManager.dialog.buttonGlow.visible = true;
};

gameController.autoplayEnded = function (autoplayData) {
  resourceManager.getController('inputOverlord').setText('autoplayCancelButton', '');

  resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;
};

StateMachine.Create(gameController);

gameController.stateMachine.addState('WAITING_FOR_LOAD', function () {});

gameController.cancelAutoplay = function () {
  resourceManager.getController('autoplayController').cancel();

  resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;
};

gameController.stateMachine.addState('WAITING_FOR_REELS', function () {
  if (gameController.phase.hold()) {
    if (gameController.spinComplete && gameController.nudgeSpinComplete) {
      gameController.phase.step();
      gameController.canSkipWin = true;
    }
  }
  if (gameController.phase.once()) {
    gameController.stateMachine.switchState('WAITING_FOR_BONUSES');
  }
});

gameController.stateMachine.addState('WAITING_FOR_BONUSES', function () {
  if (gameController.phase.hold()) {
    // Arrow animations and nudge(if needed)
    if (gameController.nudgeHasFinished || gameController.skipWinsPressed) {
      gameController.nudgeHasFinished = false;
      gameController.phase.step();
    }
  }
  if (gameController.phase.once()) {
    if (gameController.skipWinsPressed) {
      gameController.phase.step();
    }

    for (let reel = 0; reel < 5; reel++) {
      if (gameController.inFreeSpins) {
        if (gameController.fullSymbolsOnTopHitReel[reel] === 17) {
          gameController.nudgeFrameGlows[reel].active = false;
        } else {
          gameController.nudgeFrameGlows[reel].active = true;
        }
      } else {
        gameController.nudgeFrameGlows[reel].active = false;

        if (
          (gameController.fullSymbolsOnTopHitReel[reel] >= 5 && gameController.fullSymbolsOnTopHitReel[reel] <= 8) ||
          gameController.fullSymbolsOnTopHitReel[reel] === 15
        ) {
          if (
            gameController.checkForSymbolOnFullReels(gameController.fullSymbolsOnTopHitReel[reel]) &&
            gameController.fullSymbolsOnTopHitReel[reel] !== 15
          ) {
            gameController.nudgeFrameGlows[reel].active = true;
          }
        } else if (gameController.fullSymbolsOnTopHitReel[reel] === 9) {
          if (gameController.checkForSymbolOnFullReels(9)) {
            gameController.nudgeFrameGlows[reel].active = true;
          }
          for (let fish = 0; fish < 6; fish++) {
            let fishSymID = 18 + fish;
            if (gameController.fullSymbolsOnTopHitReel[reel].value === fishSymID) {
              gameController.nudgeFrameGlows[reel].active = true;
            }
          }
        }
      }
    }
    gameController.nudgeGlowIntroComplete = false;
    gameController.startNudgeFrameGlows();
  }
  if (gameController.phase.hold()) {
    // Nudge symbol frame glow (if needed)
    if (gameController.nudgeGlowIntroComplete || gameController.skipWinsPressed) {
      gameController.phase.step();
    }
  }
  if (gameController.phase.once()) {
    if (!gameController.skipWinsPressed) {
      gameController.topReelAnimationsComplete = false;
      gameController.doTopReelAnimations();
    }
  }
  if (gameController.phase.hold()) {
    // Doing top reel animations
    if (gameController.topReelAnimationsComplete || gameController.skipWinsPressed) {
      gameController.phase.step();
    }
  }
  if (gameController.phase.once()) {
    gameController.canSkipWin = false;

    if (gameController.bonusSymbolsLanded >= 3) {
      gameController.displayBonusEntryAnims();
    } else {
      gameController.setState_WaitingForServer(gameController.spinTask);
    }
  }
});

gameController.stateMachine.addState('WAITING_FOR_START', function () {
  if (gameController.phase.hold()) {
    if (!resourceManager.getController('autoplayController').LimitPopupOpen) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    resourceManager.getController('inputOverlord').setState('enabled');

    if (!autoplayManager.isAutoplayEnabled() && !gameController.justHadFreeSpins) {
      gameController.cyclingWins = true;
      gameController.cyclingJustWinlines = false;
      timerManager.addTimeout(1500, function () {
        if (gameController.cyclingWins) {
          gameController.cycleWins();
        }
      });
    }
  }

  if (gameController.phase.hold()) {
    // Waiting for player to do something
    if (autoplayManager.isAutoplayEnabled()) {
      if (autoplayManager.AP.getFields()['numberOfRounds'].currentValue !== autoplayManager.AP.roundsRemaining()) {
        var timeToNext = 500;
        resourceManager.getController('autoplayController').timeToNextAutoplay = timeToNext;
        gameController.phase.step();
      }
    }
  }

  if (gameController.phase.timed(resourceManager.getController('autoplayController').timeToNextAutoplay)) {
  }

  if (gameController.phase.once()) {
    gameController.startGame();
    if (autoplayManager.AP.roundsRemaining() === 0) {
      // Last round, so cancel autoplays
      gameController.cancelAutoplay();
    }
  }
});

gameController.stateMachine.addState('SPIN_REELS_SPINNING', function () {});

gameController.stateMachine.addState('WAITING_FOR_SERVER', function () {});

gameController.stateMachine.addState('PAYING_TO_WINNINGS', function () {
  if (gameController.phase.enter()) {
    winMeter.meter.cancelCountUp();

    soundManager.play('winCountUp');
  }
  if (gameController.phase.hold()) {
    if (!gameData.winningsMeter.Props.isCounting) {
      // Finished counting
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get('winningsMeterLabel').visible = true;
      }

      gameController.unFadeSymbols();

      gameController.stateMachine.switchState('DELAY_SHOW_WINNINGS');

      soundManager.stop('winCountUp');
      soundManager.play('winCountUpEnd');
    } else {
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get('winningsMeterLabel').visible = gameController.gameTime % 200 < 100;
      }
    }
  }

  if (gameController.phase.exit()) {
    if (!gameData.slotConfig.promotionActive) {
      resourceManager.get('winningsMeterLabel').visible = true;
    }
  }
});

gameController.stateMachine.addState('GAME_PLAYING', function () {
  if (gameController.phase.enter()) {
  }
});

gameController.stateMachine.addState('GAME_ENDED', function () {
  if (gameController.phase.enter()) {
    gameController.resetCashFishScale();
  }
  if (gameController.phase.once()) {
    gdk.endGame(function () {
      if (!gameData.mainTunePlaying && !gameController.inFreeSpins) {
        gameData.mainTunePlaying = true;
      }
      gameController.stateMachine.switchState('WAITING_FOR_START');
      gameController.baseSpin = true;
    });
  }
});

gameController.stateMachine.switchState('WAITING_FOR_LOAD');

gameController.update = function (delta, time) {
  gameController.stateMachine.update();
};

gameController.displayBonusEntryAnims = function () {
  soundManager.play('bonusWon');
  gameController.playMainReelBonusAnimations();
  gameController.playTopReelBonusAnimations();

  timerManager.addTimeout(1000, function () {
    gameController.setState_WaitingForServer(gameController.spinTask);
  });
};

gameController.cycleWins = function (once, callback) {
  if (gameController.cyclingWins) {
    if (gameController.cyclingJustWinlines) {
      if (gameController.lastPayWinsData !== undefined && gameController.lastPayWinsData.winningLines !== undefined) {
        gameController.cyclingWinsIndex = 0;
        gameController.cycleWin();
      }
    } else {
      gameController.cycleCashFishWins();
    }
  }
};

gameController.cycleWin = function () {
  let canCelebrate =
    this.lastPayWinsData.totalLineWinnings > resourceManager.getController('stakeController').CurrentStake;

  if (gameController.justCaughtFish) {
    gameController.cyclingJustWinlines = false;
    gameController.cyclingWinsIndex = 0;
    gameController.cycleNextWin();
    return;
  }

  if (gameController.lastPayWinsData.winningLines.length !== 0) {
    gameController.symbolAnimating = true;

    let data = gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex];

    let symbols = [];

    for (let i = 0; i < data.positions.length; ++i) {
      symbols.push({
        cell: { reel: data.positions[i].reel, row: data.positions[i].row },
        symbolId: data.symbol.ids[i],
      });
    }

    gameData.winningsText.setText(data.winAmount);
    gameData.winningsText.animate(false, true);

    if (canCelebrate) {
      gameController.symbolAnimator.animateSymbols(
        symbols,
        gameController.slotMachine,
        canCelebrate,
        false,
        function () {
          gameController.cycleWinDelay();
        }
      );
    } else {
      timerManager.addTimer(500, undefined, function () {
        gameController.cycleWinDelay();
      });
    }

    let frameData = {
      winningLines: [gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex]],
    };

    gameController.displaySymbolFrames(frameData);

    gameController.animating = true;

    gameController.winlineAnimator.playAnimations(
      [gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex]],
      function () {
        gameController.animating = false;
        gameController.symbolAnimating = false;
        gameController.symbolAnimator.skip();
      },
      true,
      false
    );
  }
};

gameController.cycleWinDelay = function () {
  timerManager.addTimer(1000, undefined, function () {
    gameController.symbolAnimating = false;
    gameController.cycleNextWin();
  });
};

gameController.cycleNextWin = function () {
  if (!gameController.justCaughtFish) {
    if (
      gameController.cyclingWins &&
      !gameController.symbolAnimating &&
      !gameController.animating &&
      gameController.lastPayWinsData &&
      gameController.lastPayWinsData.winningLines
    ) {
      if (gameController.cyclingWinsIndex < gameController.lastPayWinsData.winningLines.length) {
        gameController.cycleWin();
        ++gameController.cyclingWinsIndex;
      } else {
        gameController.cyclingJustWinlines = false;
        gameController.cycleWins();
      }
    }
  } else {
    gameController.cyclingJustWinlines = false;
    gameController.cycleWins();
  }

  gameController.muteCyclingWins = true;
};

gameController.cycleCashFishWins = function () {
  let cashFishWin = false;

  for (let i = 0; i < gameController.fishermanCashValues.length; i++) {
    if (gameController.fishermanCashValues[i] > 0) {
      cashFishWin = true;
    }
  }

  if (
    gameController.lastPayWinsData &&
    gameController.lastPayWinsData.totalLineWinnings !== undefined &&
    gameController.lastPayWinsData.totalLineWinnings > 0 &&
    gameController.lastPayWinsData.winningLines.length === 0
  ) {
    gameController.justCaughtFish = true;
  } else {
    gameController.justCaughtFish = false;
  }

  if (!cashFishWin) {
    gameController.cyclingJustWinlines = true;
    gameController.cyclingWinsIndex = 0;
    gameController.cycleNextWin();
  } else {
    let fishWinsOnly = gameController.reelsPrize - gameController.lineWinsOnly;
    gameData.winningsText.setText(fishWinsOnly);
    gameData.winningsText.animate(false, true);
    gameController.pulseCashFishValues();
    gameController.cyclingWinsIndex = 0;

    timerManager.addTimer(2000, undefined, function () {
      gameController.cycleWinDelay();
    });
  }
};

gameController.onLimitsPopupClosed = function () {
  soundManager.play(gameData.sounds.buttonPressed);
  gameController.stateMachine.switchState('GAME_ENDED');
};

gameController.onStakeChanged = function (stake) {
  const currentStake = gameData.stakes[gameData.currentStakeIndex];
  if (currentStake !== stake) {
    gameData.currentStakeIndex = gameData.stakes.indexOf(stake);
    // gameController.winningsContainer.visible = false;
    gameData.winningsMeter.set(0);
    gameController.totalWinnings = 0;
    game.changeStake(stake);
    gameController.currentStake = stake;

    if (!gameController.stakeChangedDueToMagicBet) {
      gameController.cyclingWins = false;
      gameController.lastPayWinsData = undefined;
    }
    gameController.stakeChangedDueToMagicBet = false;

    //winlineAnimationController.skipAnimations();
  }
};

gameController.getCurrentModeStake = function (ignoreGoldenBetMultiplier) {
  let stake = 0;

  const stakeController = resourceManager.getController('stakeController');

  if (stakeController) {
    stake = stakeController.getCurrentStake('default');

    if (gameController.inBuyABonus) {
      stake = stakeController.getCurrentStake(gameController.buyBonusMode);
    }

    // in golden bet the fireball values are based on the base stake so multiply down
    //let goldenBetButton = resourceManager.get(
    //  'buttonContainer:reflexButtonBar:goldenBetToggleButton'
    //);
    //if (
    //  ignoreGoldenBetMultiplier &&
    //  goldenBetButton !== undefined &&
    //  goldenBetButton._flags.showGoldenBetActive
    //) {
    //  stake = stake / 1.5;
    //}
  }
  return stake;
};

gameController.onGameComplete = function () {
  if (!gameController.isPrepaid && !gameController.inRecovery) {
    gameData.creditMeter.set(gameData.credit + gameController.totalWinnings);
  }

  if (gameController.inBuyABonus) {
    // keep the buy bonus stake
    resourceManager.getController('stakeController').broadcastCurrentStake('default');
  }

  //gameController.stateMachine.switchState('WAITING_FOR_START');

  gdk.endGame(function () {
    if (!gameData.mainTunePlaying && !gameController.inFreeSpins) {
      gameData.mainTunePlaying = true;
    }
    resourceManager.getController('autoplayController').checkLimits();
    // Check again in case we just cancelled autoplay
    if (autoplayManager.isAutoplayEnabled() === false) {
      resourceManager.getController('inputOverlord').setState('enabled');

      gameController.stateMachine.switchState('WAITING_FOR_START');
    } else {
      // Next game is AUTOPLAY
      gameController.stateMachine.switchState('WAITING_FOR_START');
    }

    if (!musicManager.wasInFreeSpins) {
      musicManager.onGameEnd();
    } else {
      musicManager.wasInFreeSpins = false;
    }
  });
};

gameController.doSlamStop = function () {
  if (gameData.reelsSpinning > 0 || gameData.nudgeReelsSpinning > 0) {
    spinController.longSpinMainReels = [false, false, false, false, false];
    spinController.longSpinNudgeReels = [false, false, false, false, false];

    gameController.slamStopped = true;

    // Cancel any pending resetReels timer from previous spin
    if (gameController.resetReelsTimer) {
      timerManager.stop(gameController.resetReelsTimer);
      gameController.resetReelsTimer = undefined;
    }
    // Immediately call resetReels since slam stop has occurred
    gameController.resetReels();

    soundManager.stop('reelAnticipation');
    soundManager.stop('topReelAnticipation');

    gameController.reelsToSlam = [];
    for (let i = 0; i < gameData.reels.length; ++i) {
      gameController.reelsToSlam.push(i);
    }

    gameController.symbolOverlayDisplay.hideAllBonusOverlays();

    // Sometimes the nudge reels land in the wrong place and need adjusting
    this.setReelsOnError();

    gameController.slotMachine.slamReels(gameController.reelsToSlam);

    gameController.nudgeSlotMachine.slamReels(gameController.reelsToSlam);

    // Ensure bonus symbol 15 overlays are displayed properly after slam stop
    timerManager.addTimeout(10, function () {
      // Reset bonus counter so all symbols animate with consistent state
      gameController.bonusSymbolsLanded = 0;
      // Clean up any existing symbol animations and animator pool state
      gameController.symbolLandAnimator.skip();
      // Display bonus overlays for main reels
      gameController.playMainReelBonusAnimations();
      // Display bonus overlays for top reels
      //gameController.playTopReelBonusAnimations();
    });
  }
};

gameController.setReelsOnError = function () {
  const topReelSyms = gameController.getTopReelBeforeNudge();

  for (let i = 0; i < gameController.nudgeSlotMachine.reels.length; i++) {
    // Skip if this reel was already adjusted
    if (gameController.adjustedTopReels[i]) {
      continue;
    }

    let landOffset = spinController.nudgeLandOffsets[i];
    const symbolSymbolBlank =
      topReelSyms[i].symbols[0].value !== 17 &&
      topReelSyms[i].symbols[1].value !== 17 &&
      topReelSyms[i].symbols[2].value === 17;

    const symbolBlankBlank =
      topReelSyms[i].symbols[0].value !== 17 &&
      topReelSyms[i].symbols[1].value === 17 &&
      topReelSyms[i].symbols[2].value === 17;

    // If landoffset is negative, we need to nudge the reel up further to for the wrong placement
    // If landoffset is positive, the reel will already be in the right place

    if (landOffset !== undefined && landOffset < 0) {
      landOffset = +landOffset;
      const topReel = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel' + i);
      topReel.y = 0;

      if (symbolBlankBlank || symbolSymbolBlank) {
        const baseAdjustment = gameController.nudgeSectorSize * 4; // 208px

        if (gameController.slamStopped) {
          // Slam stop - abrupt adjustment
          topReel.y -= baseAdjustment;
        } else {
          // Normal spin - smooth entry from off-screen
          const extraForReentry = gameController.nudgeSectorSize * 3; // 156px extra
          topReel.y -= baseAdjustment + extraForReentry; // Move further up (off-screen)

          // Tween back down so symbol slides smoothly into view
          gsap.to(topReel, {
            duration: 2,
            y: '+=' + extraForReentry,
            ease: 'power2.out',
            overwrite: true,
          });
        }

        // Mark reel as adjusted so we can reset animations which will have been affected
        gameController.adjustedTopReels[i] = true;

        // Store the container position at the moment of adjustment
        let nudgeSlotContainer = resourceManager.get('nudgeSlotContainer');
        gameController.adjustedReelContainerY[i] = nudgeSlotContainer ? nudgeSlotContainer.y : 0;
        gameController.adjustedReelContainerX[i] = nudgeSlotContainer ? nudgeSlotContainer.x : 0;

        // Store the fisherman (leprechaun) target position at the moment of adjustment
        gameController.adjustedReelFishermanPos[i] = helpers.getNudgeSymbolPos(i);
        gameController.adjustedReelFishermanPos[i].y += SLAM_STOP_FISHERMAN_OFFSET;
      }
    }
  }
};

gameController.getRandomBezierPoint = function (startPoint, endPoint, distanceScaler, direction) {
  // pass in undefined for unneeded parameters and it will pick a hopefully sensible default value
  // distanceScaler - (0.0 - 1.0) - Distance to move the bezier point away from the line - 0.0 = no movement, 1.0 = full line distance
  if (distanceScaler === undefined) {
    distanceScaler = 0.25; // Default to 25% of the line distance
  } else {
    // Clamp the distance scaler to 0.0 - 1.0
    distanceScaler = Math.min(1.0, Math.max(0.0, distanceScaler));
  }
  // direction - (0 or 1) - direction to move the bezier point - 0 = right, 1 = left
  // from the perspective of the line direction, stood at start point looking at end point
  if (direction !== 0 && direction !== 1) {
    direction = Math.floor(Math.random() * 2);
  }

  const midPoint = {
    x: (startPoint.x + endPoint.x) / 2,
    y: (startPoint.y + endPoint.y) / 2,
  };
  const directionVector = {
    x: endPoint.x - startPoint.x,
    y: endPoint.y - startPoint.y,
  };
  const mainLineMagnitude = Math.sqrt(directionVector.x ** 2 + directionVector.y ** 2);
  const distance = mainLineMagnitude * distanceScaler;
  const perpendicularVector = { x: -directionVector.y, y: directionVector.x };
  const perpendicularMagnitude = Math.sqrt(perpendicularVector.x ** 2 + perpendicularVector.y ** 2);
  perpendicularVector.x /= perpendicularMagnitude;
  perpendicularVector.y /= perpendicularMagnitude;
  const scaledPerpendicularVector = {
    x: perpendicularVector.x * distance,
    y: perpendicularVector.y * distance,
  };

  let xPos;
  let yPos;

  if (direction === 0) {
    xPos = midPoint.x + scaledPerpendicularVector.x;
    yPos = midPoint.y + scaledPerpendicularVector.y;
  } else {
    xPos = midPoint.x - scaledPerpendicularVector.x;
    yPos = midPoint.y - scaledPerpendicularVector.y;
  }

  const bezierPoint = { x: xPos, y: yPos };
  return bezierPoint;
};

gameController.getWildMultiplierPanelSymIndex = function (symbolID) {
  // Jamie - why have I done this?
  // Still bad, but at least only in one place now
  let symIndex = -1;
  if (symbolID === 5) {
    symIndex = 3;
  } else if (symbolID === 6) {
    symIndex = 2;
  } else if (symbolID === 7) {
    symIndex = 1;
  } else if (symbolID === 8) {
    symIndex = 0;
  } else if (symbolID === 9) {
    symIndex = 4;
  }
  return symIndex;
};

gameController.calculateMagnitude = function (startPos, endPos) {
  const deltaX = endPos.x - startPos.x;
  const deltaY = endPos.y - startPos.y;
  return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
};

gameController.calculateQuadraticBezierPosition = function (t, P0, P1, P2) {
  let x = Math.pow(1 - t, 2) * P0.x + 2 * (1 - t) * t * P1.x + Math.pow(t, 2) * P2.x;
  let y = Math.pow(1 - t, 2) * P0.y + 2 * (1 - t) * t * P1.y + Math.pow(t, 2) * P2.y;
  return { x: x, y: y };
};

gameController.doTopReelAnimations = function () {
  gameController.topReelAnimationQueue = [];
  let animationID = 0;

  // Jamie - 3 loops now to ensure ordering of queue but tidy this up later
  for (let reel = 0; reel < 5; reel++) {
    if (gameController.bonuses[reel].type === 'wildUpgrade') {
      let animData = {
        type: gameController.bonuses[reel].type,
        reel: reel,
        symbolID: gameController.fullSymbolsOnTopHitReel[reel],
        upgrades: gameController.bonuses[reel].upgrades,
        animationID: animationID,
        delay: 500,
      };
      gameController.topReelAnimationQueue.push(animData);
      animationID++;
    }
  }
  for (let reel = 0; reel < 5; reel++) {
    if (
      gameController.bonuses[reel].type === 'fishWin' &&
      (gameController.bonuses[reel].winAmount > 0 || gameController.inFreeSpins)
    ) {
      let animData = {
        type: gameController.bonuses[reel].type,
        reel: reel,
        symbolID: gameController.fullSymbolsOnTopHitReel[reel],
        animationID: animationID,
        delay: 0,
      };
      gameController.topReelAnimationQueue.push(animData);
      animationID++;
    }
  }
  for (let reel = 0; reel < 5; reel++) {
    if (gameController.bonuses[reel].type === 'extraSpin') {
      // Extra spin only available in FS
      let animData = {
        type: gameController.bonuses[reel].type,
        reel: reel,
        animationID: animationID,
        delay: 0,
      };
      gameController.topReelAnimationQueue.push(animData);
      animationID++;
    }
  }
  gameController.processTopReelAnimationQueue();
};

gameController.processTopReelAnimationQueue = function () {
  if (gameController.topReelAnimationQueue.length > 0) {
    gameController.currentTopReelAnimation = gameController.topReelAnimationQueue.shift();

    if (gameController.currentTopReelAnimation.type === 'wildUpgrade') {
      gameController.animateTopReelWildPanelMultiplierIncrease();
    } else if (gameController.currentTopReelAnimation.type === 'fishWin') {
      gameController.preCatchFish();
    } else if (gameController.currentTopReelAnimation.type === 'extraSpin') {
      gameController.animateTopReelExtraSpin();
    }
  } else {
    gameController.topReelAnimationQueueComplete();
  }
};

gameController.animateTopReelWildPanelMultiplierIncrease = function () {
  // Animate the wild panel multiplier increase if in free spins
  // or just skip to next phase if not

  const reel = gameController.currentTopReelAnimation.reel;
  gameController.stopNudgeFrameGlow(reel);

  if (gameController.inFreeSpins) {
    const symbolID = gameController.currentTopReelAnimation.symbolID;
    const wildBubble = gameController.getWildBubbleEmitter();

    const symIndex = gameController.getWildMultiplierPanelSymIndex(symbolID);

    let nudgeReel = helpers.getNudgeSymbolPos(reel);
    let startPos = { x: nudgeReel.x, y: nudgeReel.y };
    let endPos = helpers.getWildPanelSymbolPos(symIndex);
    let bezierPoint = gameController.getRandomBezierPoint(startPos, endPos);
    let animPath = [
      { x: startPos.x, y: startPos.y },
      { x: bezierPoint.x, y: bezierPoint.y },
      { x: endPos.x, y: endPos.y },
    ];

    //wildBubble.emitter.x = startPos.x;
    //wildBubble.emitter.y = startPos.y;

    const magnitude = gameController.calculateMagnitude(startPos, endPos);
    const animTime = magnitude / gameController.wildPanelParticleSpeedScaler;

    let emitterSpawnPos = {
      x: startPos.x,
      y: startPos.y,
    };
    wildBubble.emitter.particleEmitter.updateOwnerPos(emitterSpawnPos.x, emitterSpawnPos.y);

    // Jamie - update later
    gsap.to(emitterSpawnPos, {
      duration: animTime,
      ease: 'linear',
      x: endPos.x,
      y: endPos.y,
      //motionPath: {
      //  path: animPath
      //},
      onStart: () => {
        wildBubble.emitter.particleEmitter.emit = true;
        wildBubble.emitter.visible = true;
      },
      onUpdate: () => {
        wildBubble.emitter.particleEmitter.updateOwnerPos(emitterSpawnPos.x, emitterSpawnPos.y);
      },
      onComplete: () => {
        wildBubble.emitter.particleEmitter.emit = false;
        wildBubble.emitter.visible = false;
        gameController.returnWildBubbleEmitter(wildBubble.id);

        gameController.animateTopReelWildOntoMainReels();
        gameController.freeSpinsWildPanel.updateWildMultiplierPanel(symbolID, function () {});
      },
    });
  } else {
    gameController.animateTopReelWildOntoMainReels();
  }
};

gameController.animateTopReelWildOntoMainReels = function () {
  // Cycle through the upgrades for this symbol on the nudge reel
  // Trigger the particle emitter effect with a slight gap between each
  // Only leave when all upgrades have been processed
  // If no upgrades, just skip to next phase

  const topHitReel = gameController.currentTopReelAnimation.reel;
  const upgrades = gameController.currentTopReelAnimation.upgrades;
  const totalUpgradeCount = upgrades.length;
  const symbolID = gameController.currentTopReelAnimation.symbolID;

  if (totalUpgradeCount <= 0) {
    gameController.currentTopReelAnimation.delay = 0;
    gameController.checkForAnimationDelay();
    return;
  }

  let nudgeReel = helpers.getNudgeSymbolPos(topHitReel);
  let currentUpgrade = 0;
  let upgradesComplete = 0;

  for (let i = 0; i < totalUpgradeCount; i++) {
    let reel = upgrades[i].coord.reel;
    let row = upgrades[i].coord.row;
    let reelObject = gameData.reels[reel];
    let wildSymbol = upgrades[i].upgradeSymbol;

    let wildBubble = gameController.getWildBubbleEmitter();
    let mainReelPos = helpers.getSymbolPos(reel, row);
    currentUpgrade++;

    let startPos = { x: nudgeReel.x, y: nudgeReel.y };
    // If this reel was adjusted for the slam stop offset, move the start pos down too
    if (gameController.adjustedTopReels[topHitReel]) {
      startPos.y += SLAM_STOP_FISHERMAN_OFFSET;
    }

    let endPos = { x: mainReelPos.x, y: mainReelPos.y };
    let bezierPoint = gameController.getRandomBezierPoint(startPos, endPos);
    let animPath = [
      { x: startPos.x, y: startPos.y },
      { x: bezierPoint.x, y: bezierPoint.y },
      { x: endPos.x, y: endPos.y },
    ];

    //wildBubble.emitter.x = startPos.x;
    //wildBubble.emitter.y = startPos.y;

    const magnitude = gameController.calculateMagnitude(startPos, endPos);
    const animTime = magnitude / gameController.mainReelsParticleSpeedScaler;

    let emitterSpawnPos = {
      x: startPos.x,
      y: startPos.y,
    };
    wildBubble.emitter.particleEmitter.updateOwnerPos(emitterSpawnPos.x, emitterSpawnPos.y);

    gsap.to(emitterSpawnPos, {
      duration: animTime,
      ease: 'linear',
      x: endPos.x,
      y: endPos.y,
      delay: 0.05 * i,
      //motionPath: {
      //  path: animPath
      //},
      onStart: () => {
        wildBubble.emitter.particleEmitter.emit = true;
        wildBubble.emitter.visible = true;
      },
      onUpdate: () => {
        wildBubble.emitter.particleEmitter.updateOwnerPos(emitterSpawnPos.x, emitterSpawnPos.y);
      },
      onComplete: () => {
        gameController.returnWildBubbleEmitter(wildBubble.id);
        wildBubble.emitter.particleEmitter.emit = false;
        wildBubble.emitter.visible = false;

        // Set the symbol to be a wild
        timerManager.addTimeout(200, function () {
          reelObject.setReelSymbol(row, wildSymbol);
        });
        let mainReelScaleX = resourceManager.get('slotContainer').scale.x;
        let mainReelScaleY = resourceManager.get('slotContainer').scale.y;
        gameController.wildTransitionAnims[reel][row].scale.set(mainReelScaleX, mainReelScaleY);
        gameController.wildTransitionAnims[reel][row].position = helpers.getSymbolPos(reel, row);
        gameController.wildTransitionAnims[reel][row].visible = true;
        gameController.wildTransitionAnims[reel][row].gotoAndPlay(0);
        soundManager.play(soundManifest.getSound('zapLanding'));

        upgradesComplete++;

        if (upgradesComplete === totalUpgradeCount) {
          gameController.checkForAnimationDelay();
        }
      },
    });
  }
};

gameController.preCatchFish = function () {
  soundManager.play('nudgeTopReel');

  const topHitReel = gameController.currentTopReelAnimation.reel;
  let fishermanSymbol = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel' + topHitReel);

  gsap.to(fishermanSymbol, {
    duration: 0.125,
    ease: 'sine',
    y: '-=5',
    onComplete: () => {
      gsap.to(fishermanSymbol, {
        duration: 0.125,
        ease: 'sine',
        y: '+=5',
        onComplete: () => {
          gameController.catchAllFishes();
        },
      });
    },
  });
};

gameController.catchAllFishes = function () {
  const topHitReel = gameController.currentTopReelAnimation.reel;
  let fishData = gameController.getFishData();
  let overlays = [];
  let fishermanMeter = resourceManager.get('postReelsNudge:winnings:meter' + topHitReel);
  let animationCount = 0;
  let textOffsetY = 40;

  // Get current container Y position
  let nudgeSlotContainer = resourceManager.get('nudgeSlotContainer');
  let currentContainerY = nudgeSlotContainer ? nudgeSlotContainer.y : 0;
  let fishermanPos;

  // If this reel was adjusted, use the stored position from when it was adjusted
  if (gameController.adjustedTopReels[topHitReel] && gameController.adjustedReelFishermanPos[topHitReel]) {
    let adjustedContainerY = gameController.adjustedReelContainerY[topHitReel];
    let adjustedContainerX = gameController.adjustedReelContainerX[topHitReel];
    let currentContainerX = nudgeSlotContainer ? nudgeSlotContainer.x : 0;

    // Start with the stored position
    fishermanPos = {
      x: gameController.adjustedReelFishermanPos[topHitReel].x,
      y: gameController.adjustedReelFishermanPos[topHitReel].y,
    };

    // Adjust fishermanPos if container has moved since adjustment
    if (currentContainerX !== adjustedContainerX) {
      let containerChangeX = currentContainerX - adjustedContainerX;
      fishermanPos.x += containerChangeX;
    }
    if (currentContainerY !== adjustedContainerY) {
      let containerChangeY = currentContainerY - adjustedContainerY;
      fishermanPos.y += containerChangeY;
    }

    let animatorY = ANIMATOR_Y_BASE_OFFSET;

    if (currentContainerY === PORTRAIT_CONTAINER_Y) {
      animatorY += ANIMATOR_Y_PORTRAIT_COMPENSATION;
      animatorY -= currentContainerY;
    }

    // Store the reel adjustment which will be checked in movieAnimator
    // when setting the animation position
    gameController.nudgeAnimationYAdjustment[topHitReel] = animatorY;
    gameController.nudgeSymbolAnimator.y = 0;
  } else {
    fishermanPos = helpers.getNudgeSymbolPos(topHitReel);
    gameController.nudgeSymbolAnimator.y = 0;
  }

  gameController.stopNudgeFrameGlow(topHitReel);

  let fishermanMeterFrame = resourceManager.get('postReelsNudge:winnings:frame' + topHitReel);
  fishermanMeter.set(0);

  let symbols = [];
  symbols.push({ cell: { reel: topHitReel, row: 1 }, symbolId: 24 });

  let symbolTotal = 0;

  if (gameController.inFreeSpins && fishData.length === 0) {
    gameController.animateMultiplierIncrease(fishermanPos, topHitReel);
    return;
  }

  soundManager.play(soundManifest.getSound('collectCashPot'));

  let totalFishWin = 0;

  for (let i = 0; i < fishData.length; i++) {
    totalFishWin += fishData[i].amount;
  }

  gameController.fishermanCashValues[topHitReel] = totalFishWin;
  gameController.fishCashOverlayAnimations = [];

  for (let i = 0; i < fishData.length; i++) {
    let reel = fishData[i].coord.reel;
    let row = fishData[i].coord.row;
    let container = resourceManager.get('particlesContainerFront');
    let overlayPosX = helpers.getSymbolPos(reel, row).x;
    let overlayPosY = helpers.getSymbolPos(reel, row).y;
    let baseVal = fishData[i].amount;
    let formattedVal = gdk.formatCurrency(baseVal);

    // Add moveable overlays
    let overlay = resourceManager.createObject(
      'text',
      `moveableCashOverlayReel${reel}Row${row}BonusReel${i}`,
      container,
      {
        text: formattedVal,
        fontDefinition: 'cashFish',
        maxWidth: 140,
        anchor: 0.5,
        x: overlayPosX,
        y: overlayPosY + 55,
        visible: false,
      }
    );

    overlays.push(overlay);

    // Add emitters
    // Add cash fish buble particles
    let cashFishBubble = particleManager.createEmitter(
      'cashFishBubbles',
      'particlesContainerFront',
      overlay.x,
      overlay.y,
      false
    );
    cashFishBubble.particleEmitter.emit = false;
    cashFishBubble.visible = false;

    animationCount++;

    const animation = gsap.to(overlays[i], {
      duration: 1,
      ease: 'linear',
      x: fishermanPos.x,
      y: fishermanPos.y + textOffsetY,
      onStart: () => {
        gameController.nudgeSymbolAnimator.animateSymbols(
          symbols,
          gameController.nudgeSlotMachine,
          true,
          false,
          function () {},
          function () {}
        );

        symbolTotal += fishData[i].amount;

        fishermanMeter.visible = true;
        fishermanMeter.countUp(totalFishWin, 750);

        fishermanMeterFrame.visible = true;

        overlays[i].visible = true;

        cashFishBubble.particleEmitter.emit = true;
        cashFishBubble.visible = true;
      },
      onComplete: () => {
        fishermanMeter.set(totalFishWin);
        overlays[i].visible = false;
        resourceManager.destroyObject(overlays[i].name);
        resourceManager.destroyObject(cashFishBubble);

        animationCount--;

        if (animationCount === 0) {
          gsap.to(fishermanMeter, {
            duration: 1,
            ease: 'linear',

            delay: 0,
            onStart: () => {},
            onComplete: () => {
              overlays = [];

              if (gameController.inFreeSpins) {
                gameController.animateFishermanMultiplier(topHitReel);
              } else {
                gameController.checkForAnimationDelay();
              }
            },
          });
        }
      },
    });
    this.fishCashOverlayAnimations.push(animation);
  }
};

gameController.animateFishermanMultiplier = function (reel) {
  let fishermanPos = helpers.getNudgeSymbolPos(reel);

  if (gameController.currentFishermanMultiplier >= 2) {
    let multiplierText = gameController.topReelMultiplierText[reel];
    multiplierText.position = fishermanPos;
    multiplierText.position.y -= 10;
    multiplierText.setText('x' + gameController.currentFishermanMultiplier);
    multiplierText.scale.set(0);
    multiplierText.visible = true;

    const animation = gsap.to(multiplierText.scale, {
      duration: 0.5,
      ease: 'back.out(2)',
      x: 1,
      y: 1,
      onComplete: () => {
        gameController.countUpMultiplier(reel);
        soundManager.play('fishermanMultiplier');
      },
    });
  } else {
    gameController.animateMultiplierIncrease(fishermanPos, reel);
  }
};

gameController.countUpMultiplier = function (reel) {
  let fishermanPos = helpers.getNudgeSymbolPos(reel);
  let fishermanMeter = resourceManager.get('postReelsNudge:winnings:meter' + reel);
  let fishCash = gameController.fishermanCashValues[reel];
  let multipliedCash = fishCash * gameController.currentFishermanMultiplier;
  gameController.fishermanCashValues[reel] = multipliedCash;
  fishermanMeter.countUp(multipliedCash - fishCash, 500);

  timerManager.addTimeout(500, function () {
    gameController.scaleDownMultiplier(reel);
  });
};

gameController.scaleDownMultiplier = function (reel) {
  let fishermanPos = helpers.getNudgeSymbolPos(reel);
  let multiplierText = gameController.topReelMultiplierText[reel];
  const animation = gsap.to(multiplierText.scale, {
    duration: 0.5,
    ease: 'sine',
    x: 0,
    y: 0,
    onComplete: () => {
      multiplierText.visible = false;
      multiplierText.scale.set(1);
      gameController.animateMultiplierIncrease(fishermanPos, reel);
    },
  });
};

gameController.animateMultiplierIncrease = function (fishermanPos, reel) {
  let displayIncrease = true;
  if (gameController.inFreeSpins && gameController.lastFishermanData === undefined) {
    let lastReel = -1;
    for (let i = 0; i < gameController.fullSymbolsOnTopHitReel.length; i++) {
      if (gameController.fullSymbolsOnTopHitReel[i] === 9) {
        lastReel = i;
      }
    }

    if (lastReel === reel) {
      gameController.lastFishermanData = { reel: reel, pos: fishermanPos };
      displayIncrease = false;
    }
  }

  if (gameController.finalFreeSpin) {
    displayIncrease = true;
  }

  if (displayIncrease) {
    soundManager.play('topLeprechaunPotHighlight');
    gameController.spinSparkle(fishermanPos, 0.5, 0.5, function () {
      gameController.freeSpinsWildPanel.updateWildMultiplierPanel(9, gameController.checkForAnimationDelay);
    });
  } else {
    gameController.checkForAnimationDelay();
  }
};

gameController.animateTopReelExtraSpin = function () {
  const reel = gameController.currentTopReelAnimation.reel;
  let nudgeReel = helpers.getNudgeSymbolPos(reel);

  gameController.stopNudgeFrameGlow(reel);

  gameController.extraSpinText.x = nudgeReel.x;
  gameController.extraSpinText.y = nudgeReel.y;
  gameController.extraSpinText.alpha = 0;
  gameController.extraSpinText.scale.set(0.7);
  gameController.extraSpinText.visible = true;

  soundManager.play('bonusSpin');

  meterPos = resourceManager.get('meterContainer:freespins').position;

  gsap.to(gameController.extraSpinText, {
    duration: 0.5,
    ease: 'sine',
    alpha: 1.0,
    onComplete: () => {
      //////////////////////////////////////////////////////////////////////////
      // Jamie - Grrr, why is gsap like this, onUpdate seems completely broken
      // Temp, sort this out later
      timerManager.addTimeout(600, function () {
        gameController.fadeExtraSpinText();
      });
      //////////////////////////////////////////////////////////////////////////

      gsap.to(gameController.extraSpinText, {
        duration: 1.0,
        ease: 'sine',
        x: meterPos.x,
        y: meterPos.y,
        onComplete: () => {
          gameController.extraSpinText.visible = false;
          gameController.checkForAnimationDelay();
          messageBus.postImmediate('FreespinsExtraSpin');
        },
      });
    },
  });
};

/////////////////////////////////////////////////////////////////////
// Jamie - Get rid of these two functions, gsaps fault
gameController.fadeExtraSpinText = function () {
  timerManager.addTimer(300, gameController.fadeExtraSpinTextProgress, function () {
    gameController.extraSpinText.alpha = 0;
  });
};

gameController.fadeExtraSpinTextProgress = function (progress) {
  gameController.extraSpinText.alpha = 1 - progress;
};
/////////////////////////////////////////////////////////////////////

gameController.checkForAnimationDelay = function () {
  timerManager.addTimeout(gameController.currentTopReelAnimation.delay, function () {
    gameController.processTopReelAnimationQueue();
  });
};

gameController.topReelAnimationQueueComplete = function () {
  gameController.topReelAnimationsComplete = true;
};

gameController.doPayWins = function (winTask) {
  gameController.canSkipWin = true;
  gameController.justCaughtFish = false;

  if (winTask.data.totalLineWinnings > 0 && winTask.data.winningLines.length === 0) {
    gameController.justCaughtFish = true;
  }

  gameController.winTask = winTask;
  gameController.winTask.join();

  gameController.slotMachine.clearDimSymbolIds();
  gameController.nudgeSlotMachine.clearDimSymbolIds();

  gameController.reelsPrize = winTask.data.totalLineWinnings;
  gameController.lineWinsOnly = 0;
  gameController.dualWinOccurred = false;

  for (let i = 0; i < winTask.data.winningLines.length; i++) {
    gameController.lineWinsOnly += winTask.data.winningLines[i].winAmount;
  }

  if (gameController.lineWinsOnly !== gameController.reelsPrize) {
    if (gameController.lineWinsOnly > 0 && gameController.reelsPrize > 0) {
      gameController.dualWinOccurred = true;
    }
  }

  if (!gameController.inFreeSpins) {
    gameController.preFSReelPrize = gameController.reelsPrize;
    gameData.winningsMeter.add(gameController.winTask.data.totalLineWinnings);
    gameController.totalWinnings += gameController.winTask.data.totalLineWinnings;
  }

  let stake = resourceManager.getController('stakeController').CurrentStake;

  if (gameController.winTask.data.totalLineWinnings >= stake) {
    gameController.fadeSound([gameData.themeTuneId, gameData.freespinsThemeTuneId], 0.5, 500, false);
  }

  gameController.lastPayWinsData = winTask.data;

  // Do symbol animations

  // Jamie - tidy this up later
  if (gameController.justCaughtFish) {
    gameController.canSkipWin = false;
    gameController.winlinePreAnimsDone();
  } else {
    timerManager.addTimeout(1, function () {
      gameController.dimNoneWinningSymbols(winTask.data.winningLines);

      if (gameController.winTask.data.totalLineWinnings >= stake) {
        gameController.winControllerMain.startAnimations(
          gameController.winTask.data,
          resourceManager.getController('stakeController').CurrentStake,
          gameController.slotMachine,
          function () {
            gameController.winlinePreAnimsDone();
          }
        );
      } else {
        soundManager.play(soundManifest.getSound('lowerThanStakeWin'));

        gameController.winlinePreAnimsDone();
      }

      gameController.displaySymbolFrames(gameController.winTask.data);
    });
  }
};

gameController.displaySymbolFrames = function (data) {
  let symbols = new Set();

  for (let i = 0; i < data.winningLines.length; i++) {
    for (let j = 0; j < data.winningLines[i].positions.length; j++) {
      const symbol = JSON.stringify({
        reel: data.winningLines[i].positions[j].reel,
        row: data.winningLines[i].positions[j].row,
      });
      symbols.add(symbol);
    }
  }

  for (let i = 0; i < symbols.size; i++) {
    const sym = JSON.parse(Array.from(symbols)[i]);
    let mainReelScaleX = resourceManager.get('slotContainer').scale.x;
    let mainReelScaleY = resourceManager.get('slotContainer').scale.y;
    gameController.symbolFramePanels[sym.reel][sym.row].scale.set(mainReelScaleX, mainReelScaleY);
    gameController.symbolFramePanels[sym.reel][sym.row].position = helpers.getSymbolPos(sym.reel, sym.row);
    gameController.symbolFramePanels[sym.reel][sym.row].gotoAndStop(0);
    gameController.symbolFramePanels[sym.reel][sym.row].visible = true;
    gameController.symbolFramePanels[sym.reel][sym.row].play();
  }
};

gameController.stopSymbolFrameDisplay = function () {
  for (let i = 0; i < 5; i++) {
    for (let j = 0; j < 3; j++) {
      gameController.symbolFramePanels[i][j].visible = false;
      gameController.symbolFramePanels[i][j].gotoAndStop(0);
    }
  }
};

gameController.dimNoneWinningSymbols = function (winningLines) {
  // dim none winning symbols
  let winningPositions = [];
  for (let i = 0; i < winningLines.length; ++i) {
    let winningLine = winningLines[i];
    let positions = winningLine.positions;
    for (let j = 0; j < positions.length; ++j) {
      let cell = positions[j];
      winningPositions.push(cell.reel * 5 + cell.row);
    }
  }

  let symbolsToDim = [];
  for (let reel = 0; reel < 5; ++reel) {
    for (let row = 0; row < 3; ++row) {
      if (winningPositions.indexOf(reel * 5 + row) === -1) {
        symbolsToDim.push({ reel: reel, row: row });
      }
    }
  }

  gameController.slotMachine.dimSymbols(symbolsToDim, true, 0.3);
};

gameController.winlinePreAnimsDone = function () {
  if (gameController.dualWinOccurred && !gameController.winTask.data.isCapped) {
    gameData.winningsText.setText(Math.floor(gameController.lineWinsOnly));
    gameData.winningsText.animate(true, false);
  } else {
    gameData.winningsText.setText(Math.floor(gameController.lastPayWinsData.totalLineWinnings));
    gameData.winningsText.animate(false, false);
  }

  gameData.winningsText.show(true, 0);

  if (gameController.dualWinOccurred) {
    timerManager.addTimeout(1000, function () {
      gameController.combineFishermanMeter();
    });
  } else {
    timerManager.addTimeout(1000, function () {
      gameController.doBigWin();
    });
  }
};

gameController.combineFishermanMeter = function () {
  let overlays = [];
  let winningsTextPos = gameData.winningsText.position;

  for (let i = 0; i < gameController.fishermanCashValues.length; i++) {
    if (gameController.fishermanCashValues[i] !== 0) {
      let overlayPosX = helpers.getNudgeSymbolPos(i).x;
      let overlayPosY = helpers.getNudgeSymbolPos(i).y;

      let cashVal = gdk.formatCurrency(gameController.fishermanCashValues[i]);

      let overlay = resourceManager.createObject('text', `moveableCashOverlayTopReel${i}`, 'particlesContainerFront', {
        text: cashVal,
        fontDefinition: 'cashFish',
        maxWidth: 140,
        anchor: 0.5,
        x: overlayPosX,
        y: overlayPosY + 40,
        visible: false,
      });
      overlays.push(overlay);
    }
  }

  for (let i = 0; i < overlays.length; i++) {
    const animation = gsap.to(overlays[i], {
      duration: 1,
      ease: 'linear',
      x: winningsTextPos.x,
      y: winningsTextPos.y,
      onComplete: () => {
        resourceManager.destroyObject(overlays[i].name);
      },
    });
  }

  if (overlays.length > 0) {
    let fishWinsOnly = gameController.reelsPrize - gameController.lineWinsOnly;
    soundManager.play('winAmountCountUp');

    timerManager.addTimer(
      1000,
      function (progress) {
        let cashVal = gameController.lineWinsOnly + fishWinsOnly * progress;
        gameData.winningsText.setText(cashVal);
      },
      function () {
        soundManager.stop('winAmountCountUp');
        soundManager.play('winAmountCountUpEnd');
        gameData.winningsText.setText(gameController.reelsPrize);
        gameController.dualWinDisplay();
      }
    );
  } else {
    gameController.dualWinDisplay();
  }
};

gameController.dualWinDisplay = function () {
  timerManager.addTimeout(250, function () {
    gameController.dimNoneWinningSymbols(gameController.winTask.data.winningLines);

    gameController.canSkipWin = false;
    let stake = resourceManager.getController('stakeController').CurrentStake;

    if (gameController.winTask.data.totalLineWinnings >= stake) {
      gameController.winControllerMain.startAnimations(
        gameController.winTask.data,
        resourceManager.getController('stakeController').CurrentStake,
        gameController.slotMachine,
        function () {
          gameController.dualWinDisplayDone();
        },
        function (data) {}
      );
    } else {
      soundManager.play(soundManifest.getSound('lowerThanStakeWin'));

      gameController.dualWinDisplayDone();
    }

    gameController.displaySymbolFrames(gameController.winTask.data);
  });
};

gameController.dualWinDisplayDone = function () {
  gameData.winningsText.setText(Math.floor(gameController.lastPayWinsData.totalLineWinnings));
  gameData.winningsText.show(true, 0);
  gameData.winningsText.animateOut();
  gameController.pulseCashFishValues();

  timerManager.addTimeout(1000, function () {
    gameController.doBigWin();
  });
};

gameController.resetCashFishScale = function () {
  for (let i = 0; i < 5; i++) {
    let fishermanMeter = resourceManager.get(`postReelsNudge:winnings:meter${i}`);
    fishermanMeter.scale.set(1);
  }
};

gameController.pulseCashFishValues = function () {
  for (let i = 0; i < 5; i++) {
    let fishermanMeter = resourceManager.get(`postReelsNudge:winnings:meter${i}`);
    gsap.to(fishermanMeter.scale, {
      x: 1.5,
      y: 1.5,
      duration: 0.75,
      ease: 'power1.inOut',
      yoyo: true,
      repeat: 1,
    });
  }
};

gameController.doBigWin = function () {
  let winnings = gameController.lastPayWinsData.totalLineWinnings;
  let isBigWin = gameController.bigWin.willTriggerBigWin(winnings);

  if (isBigWin && !gameController.inFreeSpins) {
    gameController.bigWin.start(
      winnings,
      function () {
        gameController.bigWinDone();
      },
      gameController.winTask.data.isCapped
    );
  } else {
    gameController.bigWinDone();
  }
};

gameController.bigWinDone = function () {
  resourceManager.getContainer('DemoContainer').visible = true;

  if (gameController.inFreeSpins) {
    gameData.winningsMeter.countUp(gameController.lastPayWinsData.totalLineWinnings, 1500);
    gameController.totalWinnings += gameController.lastPayWinsData.totalLineWinnings;
  } else {
    gameData.winningsMeter.set(gameController.lastPayWinsData.totalLineWinnings);
    gameController.totalWinnings = gameController.lastPayWinsData.totalLineWinnings;
  }

  gameController.bigWinFinished = true;

  gameController.winlineAnimsDone();
};

gameController.winlineAnimsDone = function () {
  gameController.slotMachine.clearDimSymbolIds();
  gameController.slotMachine.dimAllSymbols(false, 0.1);
  let stake = resourceManager.getController('stakeController').CurrentStake;
  if (gameController.winTask.data.totalLineWinnings >= stake) {
    gameController.fadeSound([gameData.themeTuneId, gameData.freespinsThemeTuneId], 1, 250, true);
  }

  gameController.winlineAnimator.clearWinlines();

  gameController.winTask.leave();
  gameController.winTask = undefined;
};

gameController.skipWinAnimations = function () {
  gameController.bigWin.skip(gameController.winlineAnimsDone);
};

gameController.isAnimatingWins = function () {
  return gameController.winTask !== undefined;
};

gameController.skipWin = function () {
  if (gameController.winAnimationDelayTimer !== undefined) {
    timerManager.stop(gameController.winAnimationDelayTimer);
    gameController.winAnimationDelayTimer = undefined;
    gameController.winlineAnimsDone();
  }
  gameController.winControllerMain.skipAnimations();
  gameController.winlineAnimator.skipAnimation();

  gameController.skipWinsPressed = true;
  gameController.skipWinReset();
};

gameController.skipWinReset = function () {
  gameController.stopNudgeFrameGlows();
};

gameController.freespinsComplete = function (value) {
  gameController.reelsPrize = gameController.preFSReelPrize;
  gameController.featurePrize = value;
  gameController.stateMachine.switchState('IDLE');
};

gameController.onFreespinsStart = function () {
  // REMOVED: Don't hide bonus overlays here - they need to remain visible through the gamble/transition
  // The overlays will be correctly hidden when reels start spinning (see line ~1653)
  // if (gameController.symbolOverlayDisplay) {
  //   gameController.symbolOverlayDisplay.hideAllBonusOverlays();
  // }

  autoplayManager.stopAutoplay();
  gameController.inFreeSpins = true;
  gameController.currentFishermanMultiplier = 1;

  for (let i = 0; i < gameController.wildPanelMultipliers.length; i++) {
    gameController.wildPanelMultipliers[i] = 0;
  }
  gameController.freeSpinsWildPanel.updateWildMultipliers();
};

gameController.onFreespinsEnd = function () {
  gameData.winningsMeter.set(gameController.fsWinnings);
  gameController.justHadFreeSpins = true;
  gameController.inFreeSpins = false;
};

gameController.onFeatureStart = function (task) {
  //this._featureStartTask = task;
  //this._featureStartTask.join();
};

gameController.globalHelperGetStake = function () {
  let stake = gameData.stakes[gameData.currentStakeIndex];
  if (gameController.inBuyABonus) {
    stake *= 1; // was 100 for some reason
  } else if (gameData.currentStakeIndex === -1) {
    stake = gameController.currentStake;
  }
  return stake;
};

//NOTE: Check Bison Wilds on this
gameController.recoverGame = function (task) {
  // Recovery game with encore

  var encoreButtonLB = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');

  if (task.data.metaData === 'encore') {
    // Clear any encore effects and stop them appearing again
    gameData.encoreEnabled = task.data.metaValue;

    // Put button in the right state if not already true
    encoreButtonLB.setRecovery(true);
  } else {
    gameData.encoreEnabled = false;
    encoreButtonLB.setRecovery(false);
  }

  if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
    encoreButtonLB.setRecovery(true);
  }

  resourceManager.get('helpPageScrollContainer:helpPageScroll').close();

  gameController.inRecovery = true;

  if (task.data.metaData === 'buyABonusFreeSpins' && task.data.metaValue) {
    let stakeController = resourceManager.getController('stakeController');

    let baseStake = gameData.recoveryStake;

    if (baseStake === undefined) {
      baseStake = gameController.currentStake;
    }

    let stakes = stakeController.Stakes;
    let returnStake = stakes.find((stake) => stake === baseStake);

    if (!returnStake) {
      returnStake = stakes[0];
    }

    stakeController.requestChangeStake(returnStake);
    stakeController.requestChangeStake(baseStake, 'FREESPINS_BUY');

    // Not ideal, but staking system....
    gameData.stakeMeter.set(baseStake);
    gameData.topLayerStakeMeter.set(baseStake);

    gameController.inBuyABonus = true;
    gameController.inBuyABonusRecovery = true;
    gameController.initNewSpin();
  } else {
    musicManager.onGameStart();
    gameController.initNewSpin();

    // Update stake
    let stakeController = resourceManager.getController('stakeController');

    let baseStake = stakeController.BaseStake;
    let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;
    let luckyBetEnabled = gameData.encoreEnabled;

    stakeController.setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    game.changeStake(baseStake * (luckyBetEnabled ? 1.5 : 1), bpl);
    stakeController.broadcastCurrentStake();
  }
};

gameController.onAbortGame = function () {
  gameController.gameAborted = true;
  gameController.slotMachine.abortSpin();
  gameController.nudgeSlotMachine.abortSpin();

  soundManager.stop('topreelSpin');
  soundManager.stop('reelSpin');

  // Hide bonus overlays when resetting reels as a visual delay was present
  if (gameController.symbolOverlayDisplay) {
    gameController.symbolOverlayDisplay.hideAllBonusOverlays();
  }

  Loader.setStartingSymbols();
  Loader.setStartingNudgeSymbols();
  gameController.displayingStartingSymbols = true;
};

gameController.replayComplete = function () {
  gameController.cyclingWins = true;
  gameController.cycleWins();
};

gameController.onOrientationChange = function () {
  // Recalculate nudgeAnimationYAdjustment for any reels that need adjustment
  for (let i = 0; i < gameController.nudgeAnimationYAdjustment.length; i++) {
    // Only recalculate for reels that have been adjusted
    if (gameController.nudgeAnimationYAdjustment[i] !== 0) {
      let adjustment = ANIMATOR_Y_BASE_OFFSET;
      if (layoutController.getCurrentLayout() === 'portrait_default') {
        adjustment += ANIMATOR_Y_PORTRAIT_COMPENSATION - PORTRAIT_CONTAINER_Y;
      }
      gameController.nudgeAnimationYAdjustment[i] = adjustment;
    }
  }
};

gameController.onLayoutChange = function () {
  // Store the OLD layout before it gets updated
  const oldLayout = gameController.previousLayout;
  const newLayout = layoutController.getCurrentLayout();
  gameController.previousLayout = newLayout; // Update for next time

  if (gameController.symbolOverlayDisplay) {
    gameController.symbolOverlayDisplay.recenterOverlays();
  }

  if (gameController.nudgeFrameGlows[0]) {
    for (let i = 0; i < 5; i++) {
      gameController.nudgeFrameGlows[i].anim.position = helpers.getNudgeSymbolPos(i);
      // gameController.nudgeFrameGlows[i].anim.visible = false;
      gameController.freeSpinsWildTransitions[i].position = helpers.getNudgeSymbolPos(i);
      gameController.freeSpinsWildTransitions[i].visible = false;

      for (let j = 0; j < 3; j++) {
        gameController.wildTransitionAnims[i][j].position = helpers.getSymbolPos(i, j);
        gameController.wildTransitionAnims[i][j].visible = false;
        gameController.symbolFramePanels[i][j].position = helpers.getSymbolPos(i, j);
        gameController.symbolFramePanels[i][j].visible = false;
      }

      for (let j = 0; j < gameController.nudgeArrows[i].length; j++) {
        gameController.nudgeArrows[i][j].visible = false;
      }
    }

    for (let i = 0; i < gameController.wildBubbleEmitterPool.length; i++) {
      gameController.wildBubbleEmitterPool[i].emitter.visible = false;
    }

    for (let i = 0; i < gameController.fishCashOverlayAnimations.length; i++) {
      gameController.fishCashOverlayAnimations[i].progress(1);
    }

    for (let i = 0; i < gameController.topReelMultiplierText.length; i++) {
      let fishermanPos = helpers.getNudgeSymbolPos(i);
      let multiplierText = gameController.topReelMultiplierText[i];
      multiplierText.position = fishermanPos;
      multiplierText.position.y -= 10;

      if (
        layoutController.getCurrentLayout() === 'landscape_mobile' ||
        layoutController.getCurrentLayout() === 'landscape_default'
      ) {
        if (gameController.inFreeSpins) {
          // Account for shifted reels
          multiplierText.position.x -= 50;
        }
      }
    }

    gameController.spinningSparkle.visible = false;
  }

  gameController.resetAnticipationEmitterPositions();

  // Update nudgeReelPositions for the new layout
  // Also re-apply slam stop adjustments that were overwritten by layout change
  for (let i = 0; i < 5; i++) {
    let nudgeReel = resourceManager.get('nudgeSlotContainer:nudgeReelContainer:reel' + i);
    if (nudgeReel) {
      if (!gameController.nudgeReelPositions[i]) {
        gameController.nudgeReelPositions[i] = { x: 0, y: 0 };
      }

      gameController.nudgeReelPositions[i].x = nudgeReel.x;
      gameController.nudgeReelPositions[i].y = nudgeReel.y;

      //If this reel was adjusted for slam stop and apply adjustment
      if (gameController.adjustedTopReels[i]) {
        let adjustment = LANDSCAPE_SLAM_STOP_ADJUSTMENT;

        if (newLayout === 'portrait_default' || oldLayout === 'portrait_default') {
          adjustment = PORTRAIT_SLAM_STOP_ADJUSTMENT;
        }

        nudgeReel.y += adjustment;
      }
    }
  }

  if (resourceManager.get('buttonContainer:buttonBar:autoplayButton')) {
    let autoPlayButtonVisibility = resourceManager.get('buttonContainer:buttonBar:autoplayButton').visible;
    if (!autoPlayButtonVisibility) {
      resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;
    }
  }
};

gameController.onModal = function (event) {
  if (event.reason && event.reason !== '') {
    if (event.reason === 'Platform Paused') {
      gameController.cancelAutoplay();
      gameController.platformPaused = true;
    } else if (event.data && event.data === 'Platform Popup Open') {
      gameController.platformPopupActive = true;
    }
  } else if (event.data) {
    if (event.data === 'Platform Popup Close' && !gameController.platformPaused) {
      gameController.platformPopupActive = false;
    } else if (event.data === 'Platform Resume') {
      gameController.platformPaused = false;
    }

    if (gameController.platformPopupActive || gameController.platformPaused) {
      messageBus.post('game:modal', { reason: 'Keep locked', data: 'Keep locked' });
    }
  }
};

gameController.onGameSkipped = function (stakeInfo) {
  // we make the meter show the correct stake on a restore, but nothing seems to set the stake controller up correctly if you press skip
  // so we have a new message and we do that here
  // ideally this should be in the libs somewhere!!
  const stakeController = resourceManager.getController('stakeController');

  // now we can have bonus buys on different stakes compared to normal
  // os 1st lets make sure the stake is valid for BASIC
  const stakeIndex = stakeController.Stakes.indexOf(stakeInfo.baseStake);
  if (stakeIndex === -1 && !gameData.encoreEnabled) {
    // the bonus buy stake isnt in the BASIC stake
    // so we need to use the default
    // this is assuming default stake has been set correctly :( as everything appears to be in closures!!
    stakeInfo.baseStake = stakeController.Stakes[0];
  }

  stakeController.requestChangeStake(stakeInfo.baseStake);

  // as we skipped we should also hide the new messages
  // so the total win is shown
  // if (stakeInfo.win && stakeInfo.win > 0) {
  //   gameData.winningsMeter.visible = true;
  //   gameData.winningsMeter.set(stakeInfo.win);
  // }
};

gameController.onSettingsMenuOpen = function (event) {
  gameData.storedEncoreButtonState = gameData.encoreEnabled;
};

gameController.platformReplayStarted = function () {};

gameController.platformReplayStopped = function () {
  if (gameData.storedEncoreButtonState) {
    var encoreButtonLB = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');
    encoreButtonLB.setRecovery(gameData.storedEncoreButtonState);
  }
};

function RNG() {
  const m = 0x80000000;
  const a = 1664525;
  const c = 1013904223;

  let state;

  this.seed = function (newSeed) {
    let seedToUse = newSeed;

    if (typeof newSeed === 'string') {
      let hash = 0;
      for (let i = 0; i < newSeed.length; i++) {
        hash = newSeed.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      seedToUse = Math.abs(hash);
    }
    state = seedToUse ? seedToUse : 0;
  };

  this.seed(0);

  this.nextInt = function () {
    state = (a * state + c) % m;
    return state;
  };

  this.nextFloat = function () {
    return this.nextInt() / (m - 1);
  };
}

Reflex.addToUpdate(gameController.update);
messageBus.subscribe('common:GameSkipped', gameController.onGameSkipped);
messageBus.subscribe('spinner:SpinEvent', gameController.doSpin);
messageBus.subscribe('autoplay:started', gameController.autoplayStarted);
messageBus.subscribe('autoplay:ended', gameController.autoplayEnded);
messageBus.subscribe('stake:stakeChanged', gameController.onStakeChanged);
messageBus.subscribe('common:RecoverGame', gameController.recoverGame);
messageBus.subscribe('common:GameCompleteEvent', gameController.onGameComplete);
messageBus.subscribe('spinner:WinningLinesEvent', gameController.doPayWins);
messageBus.subscribe('game:FeatureAnnounceEvent', gameController.onFeatureStart);
messageBus.subscribe('spinner:FreeSpinsStartEvent', gameController.onFreespinsStart);
messageBus.subscribe('spinner:FreeSpinsEndEventDead', gameController.onFreespinsEnd);
messageBus.subscribe('common:AbortGame', gameController.onAbortGame);
messageBus.subscribe('platform:ReplayComplete', gameController.replayComplete);
messageBus.subscribe('game:settingsMenuOpen', gameController.onSettingsMenuOpen);
messageBus.subscribe('platform:ReplayStarted', gameController.platformReplayStarted);
messageBus.subscribe('platform:ReplayStopped', gameController.platformReplayStopped);

Reflex.registerEventHandler('layoutChange', gameController.onLayoutChange);
messageBus.subscribe('game:modal', gameController.onModal);
